export * from '../models/AddAudienceRequest';
export * from '../models/AddCreativeRequest';
export * from '../models/AdvertisingPlatformServiceAddAccountRepRequest';
export * from '../models/AdvertisingPlatformServiceAddCommissionGroupRequest';
export * from '../models/AdvertisingPlatformServiceAddSalesRepRequest';
export * from '../models/AdvertisingPlatformServiceAddUserRequest';
export * from '../models/AdvertisingPlatformServiceAppendOrderLineNoteRequest';
export * from '../models/AdvertisingPlatformServiceBatchAddAudiencesRequest';
export * from '../models/AdvertisingPlatformServiceBatchAddCreativesRequest';
export * from '../models/AdvertisingPlatformServiceBatchRemoveAudiencesRequest';
export * from '../models/AdvertisingPlatformServiceBatchRemoveCreativesRequest';
export * from '../models/AdvertisingPlatformServiceCloneOrderLineRequest';
export * from '../models/AdvertisingPlatformServiceCreateOrgNoteRequest';
export * from '../models/AdvertisingPlatformServiceDeactivateOrderLineNoteRequest';
export * from '../models/AdvertisingPlatformServicePauseSchedulesRequest';
export * from '../models/AdvertisingPlatformServicePlaySchedulesRequest';
export * from '../models/AdvertisingPlatformServiceRemoveCommissionGroupRequest';
export * from '../models/AdvertisingPlatformServiceRemoveUserRequest';
export * from '../models/AdvertisingPlatformServiceRetryReportRunRequest';
export * from '../models/AdvertisingPlatformServiceRunOneSubscriptionRequest';
export * from '../models/AdvertisingPlatformServiceRunReportRequest';
export * from '../models/AdvertisingPlatformServiceTriggerRouteRequest';
export * from '../models/AdvertisingPlatformServiceUpdateAssetRequest';
export * from '../models/AdvertisingPlatformServiceUpdateEmailMappingRequest';
export * from '../models/AdvertisingPlatformServiceUpdateFTPRequest';
export * from '../models/AdvertisingPlatformServiceUpdateOrderLineNoteRequest';
export * from '../models/AdvertisingPlatformServiceUpdatePixelRequest';
export * from '../models/AdvertisingPlatformServiceUpdatePublisherRequest';
export * from '../models/AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest';
export * from '../models/AdvertisingPlatformServiceUpdateRouteRequest';
export * from '../models/AdvertisingPlatformServiceUpdateRuleRequest';
export * from '../models/AdvertisingPlatformServiceUpdateRuleSetRequest';
export * from '../models/AdvertisingPlatformServiceUpdateSubscriptionRequest';
export * from '../models/ApproveOrderLineRequest';
export * from '../models/Apqsv1Checks';
export * from '../models/Apqsv1Dependency';
export * from '../models/Apqsv1HealthCheck';
export * from '../models/Apqsv1HealthCondition';
export * from '../models/Apqsv1Miscellanea';
export * from '../models/Apqsv1SystemStat';
export * from '../models/Billingservicev1Checks';
export * from '../models/Billingservicev1CommissionGroup';
export * from '../models/Billingservicev1Dependency';
export * from '../models/Billingservicev1HealthCheck';
export * from '../models/Billingservicev1HealthCondition';
export * from '../models/Billingservicev1Invoice';
export * from '../models/Billingservicev1InvoiceStatus';
export * from '../models/Billingservicev1ListInvoicesResponse';
export * from '../models/Billingservicev1Miscellanea';
export * from '../models/Billingservicev1Org';
export * from '../models/Billingservicev1SystemStat';
export * from '../models/Billingservicev2Invoice';
export * from '../models/Billingservicev2InvoiceStatus';
export * from '../models/Billingservicev2ListInvoicesResponse';
export * from '../models/CPMContainsInformationRelatingToAClientCpmanization';
export * from '../models/Campaignservicev1AdType';
export * from '../models/Campaignservicev1Audience';
export * from '../models/Campaignservicev1Campaign';
export * from '../models/Campaignservicev1Checks';
export * from '../models/Campaignservicev1Creative';
export * from '../models/Campaignservicev1Dependency';
export * from '../models/Campaignservicev1HealthCheck';
export * from '../models/Campaignservicev1HealthCondition';
export * from '../models/Campaignservicev1JobStatus';
export * from '../models/Campaignservicev1ListCampaignsResponse';
export * from '../models/Campaignservicev1Miscellanea';
export * from '../models/Campaignservicev1Note';
export * from '../models/Campaignservicev1NoteType';
export * from '../models/Campaignservicev1OrderLine';
export * from '../models/Campaignservicev1Status';
export * from '../models/Campaignservicev1SystemStat';
export * from '../models/CancelOrderLineDeploymentRequest';
export * from '../models/Contact';
export * from '../models/CreateCreditCardRequest';
export * from '../models/CreateDeploymentRequest';
export * from '../models/Creativeservicev1AdType';
export * from '../models/Creativeservicev1Audit';
export * from '../models/Creativeservicev1AuditResult';
export * from '../models/Creativeservicev1AuditStatus';
export * from '../models/Creativeservicev1Checks';
export * from '../models/Creativeservicev1Creative';
export * from '../models/Creativeservicev1Dependency';
export * from '../models/Creativeservicev1DeploymentType';
export * from '../models/Creativeservicev1Destination';
export * from '../models/Creativeservicev1FileType';
export * from '../models/Creativeservicev1FolderStats';
export * from '../models/Creativeservicev1HealthCheck';
export * from '../models/Creativeservicev1HealthCondition';
export * from '../models/Creativeservicev1ListCreativesResponse';
export * from '../models/Creativeservicev1Miscellanea';
export * from '../models/Creativeservicev1NativeMetadata';
export * from '../models/Creativeservicev1OrderLine';
export * from '../models/Creativeservicev1Status';
export * from '../models/Creativeservicev1SystemStat';
export * from '../models/Creativeservicev1Type';
export * from '../models/CreditCard';
export * from '../models/CreditCard1';
export * from '../models/DeployMetadataDeployedCPM';
export * from '../models/DeployOrderLineRequest';
export * from '../models/Deployservicev3Audit';
export * from '../models/Deployservicev3AuditResult';
export * from '../models/Deployservicev3AuditStatus';
export * from '../models/Deployservicev3Campaign';
export * from '../models/Deployservicev3Checks';
export * from '../models/Deployservicev3Creative';
export * from '../models/Deployservicev3CreativeID';
export * from '../models/Deployservicev3Dependency';
export * from '../models/Deployservicev3Deployment';
export * from '../models/Deployservicev3DeploymentType';
export * from '../models/Deployservicev3Destination';
export * from '../models/Deployservicev3HealthCheck';
export * from '../models/Deployservicev3HealthCondition';
export * from '../models/Deployservicev3ListCampaignsResponse';
export * from '../models/Deployservicev3ListCreativesResponse';
export * from '../models/Deployservicev3Miscellanea';
export * from '../models/Deployservicev3NativeMetadata';
export * from '../models/Deployservicev3Status';
export * from '../models/Deployservicev3SystemStat';
export * from '../models/Deployservicev3Value';
export * from '../models/DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries';
export * from '../models/ExistingUserWithNewFieldValues';
export * from '../models/GetDefaultTemplateRequest';
export * from '../models/GlobalSearchResponseCount';
export * from '../models/GoogleprotobufAny';
export * from '../models/GooglerpcStatus';
export * from '../models/Hagridv1Checks';
export * from '../models/Hagridv1Dependency';
export * from '../models/Hagridv1FileMetaData';
export * from '../models/Hagridv1HealthCheck';
export * from '../models/Hagridv1HealthCondition';
export * from '../models/Hagridv1ListUsersResponse';
export * from '../models/Hagridv1Miscellanea';
export * from '../models/Hagridv1SystemStat';
export * from '../models/Hagridv1User';
export * from '../models/Job';
export * from '../models/LockOrderLineRequest';
export * from '../models/MoveOrgsRequest';
export * from '../models/Notification';
export * from '../models/Notificationservicev1Checks';
export * from '../models/Notificationservicev1Dependency';
export * from '../models/Notificationservicev1HealthCheck';
export * from '../models/Notificationservicev1HealthCondition';
export * from '../models/Notificationservicev1Miscellanea';
export * from '../models/Notificationservicev1SystemStat';
export * from '../models/Notificationservicev1Type';
export * from '../models/OrderLineJobErrorDetail';
export * from '../models/OrderLineViantAdelphicIDsSetAudienceID';
export * from '../models/Orgmanagerv1Checks';
export * from '../models/Orgmanagerv1CommissionGroup';
export * from '../models/Orgmanagerv1Contact';
export * from '../models/Orgmanagerv1Dependency';
export * from '../models/Orgmanagerv1HealthCheck';
export * from '../models/Orgmanagerv1HealthCondition';
export * from '../models/Orgmanagerv1Miscellanea';
export * from '../models/Orgmanagerv1Note';
export * from '../models/Orgmanagerv1NoteType';
export * from '../models/Orgmanagerv1Org';
export * from '../models/Orgmanagerv1Status';
export * from '../models/Orgmanagerv1SystemStat';
export * from '../models/Orgmanagerv1Timeframe';
export * from '../models/Orgmanagerv1User';
export * from '../models/Orgmanagerv2ListUsersResponse';
export * from '../models/Orgmanagerv2User';
export * from '../models/PauseOrderLineRequest';
export * from '../models/PayInvoiceRequest';
export * from '../models/PaySetUpFeeRequest';
export * from '../models/PixelNote';
export * from '../models/PlayOrderLineRequest';
export * from '../models/PrepayRequest';
export * from '../models/ProtobufNullValue';
export * from '../models/RejectOrderLineRequest';
export * from '../models/RemoveAudienceRequest';
export * from '../models/RemoveCreativeRequest';
export * from '../models/RequestReviewRequest';
export * from '../models/SetDistributionRequest';
export * from '../models/StartReviewRequest';
export * from '../models/StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries';
export * from '../models/StreamResultOfV1DownloadAudienceFileResponse';
export * from '../models/StreamResultOfV1DownloadBundleResponse';
export * from '../models/StreamResultOfV1DownloadCreativeFileResponse';
export * from '../models/StreamResultOfV1DownloadExclusionAddressesResponse';
export * from '../models/StreamResultOfV1DownloadJobFileResponse';
export * from '../models/StreamResultOfV1DownloadTOSAgreementResponse';
export * from '../models/StreamResultOfV2DownloadTargetFileResponse';
export * from '../models/SubscriptionNote';
export * from '../models/Targetjobservicev1Audience';
export * from '../models/Targetjobservicev1Checks';
export * from '../models/Targetjobservicev1Column';
export * from '../models/Targetjobservicev1Dependency';
export * from '../models/Targetjobservicev1Deployment';
export * from '../models/Targetjobservicev1FolderStats';
export * from '../models/Targetjobservicev1HealthCheck';
export * from '../models/Targetjobservicev1HealthCondition';
export * from '../models/Targetjobservicev1JobStatus';
export * from '../models/Targetjobservicev1Miscellanea';
export * from '../models/Targetjobservicev1Note';
export * from '../models/Targetjobservicev1NoteType';
export * from '../models/Targetjobservicev1SystemStat';
export * from '../models/Targetjobservicev1Timeframe';
export * from '../models/Targetorchestratorv2Checks';
export * from '../models/Targetorchestratorv2Column';
export * from '../models/Targetorchestratorv2Dependency';
export * from '../models/Targetorchestratorv2FileMetaData';
export * from '../models/Targetorchestratorv2FileType';
export * from '../models/Targetorchestratorv2FolderStats';
export * from '../models/Targetorchestratorv2HealthCheck';
export * from '../models/Targetorchestratorv2HealthCondition';
export * from '../models/Targetorchestratorv2Location';
export * from '../models/Targetorchestratorv2Miscellanea';
export * from '../models/Targetorchestratorv2SystemStat';
export * from '../models/TheAdvertiserToCreate';
export * from '../models/TheAudienceToUpdate';
export * from '../models/TheAutomationToUpdate';
export * from '../models/TheCampaignToCreate';
export * from '../models/TheCampaignToUpdate';
export * from '../models/TheCreativeToCreate';
export * from '../models/TheCreativeToUpdate';
export * from '../models/TheDeploymentToCreate';
export * from '../models/TheNoteToUpdate';
export * from '../models/TheOrderLineToUpdate';
export * from '../models/TheOrganizationToUpdate';
export * from '../models/TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask';
export * from '../models/TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask';
export * from '../models/TheSegmentToCreate';
export * from '../models/TheTargetToUpdate';
export * from '../models/TypeDate';
export * from '../models/TypeMoney';
export * from '../models/UnlockOrderLineRequest';
export * from '../models/UpdateCPMsRequest';
export * from '../models/UpdateDeploymentRequest';
export * from '../models/V1AccountingJob';
export * from '../models/V1AccountingJobKind';
export * from '../models/V1AdditionalArguments';
export * from '../models/V1AdminInvoice';
export * from '../models/V1AdminListNotificationsResponse';
export * from '../models/V1ArchiveCampaignRequest';
export * from '../models/V1ArchiveCreativeRequest';
export * from '../models/V1ArchiveOrderLineRequest';
export * from '../models/V1Asset';
export * from '../models/V1AssetType';
export * from '../models/V1Assignment';
export * from '../models/V1AttachExcludedAddressesRequest';
export * from '../models/V1Attachment';
export * from '../models/V1AudienceAdded';
export * from '../models/V1AudienceFileType';
export * from '../models/V1AudienceRemoved';
export * from '../models/V1AudienceStatus';
export * from '../models/V1AudienceSubType';
export * from '../models/V1AudienceType';
export * from '../models/V1AuditConditions';
export * from '../models/V1Authorization';
export * from '../models/V1Automation';
export * from '../models/V1AutomationType';
export * from '../models/V1AuxiliaryFileFilter';
export * from '../models/V1Balance';
export * from '../models/V1BatchAddAudiencesRequestAudience';
export * from '../models/V1BatchUpdateOrderLinesRequest';
export * from '../models/V1BatchUpdateOrderLinesResponse';
export * from '../models/V1BatchUpdateOrgsRequest';
export * from '../models/V1BatchUpdateOrgsResponse';
export * from '../models/V1BrandingMode';
export * from '../models/V1BundleRequest';
export * from '../models/V1CPM';
export * from '../models/V1CPMOverride';
export * from '../models/V1CampaignArchived';
export * from '../models/V1CampaignCreated';
export * from '../models/V1CampaignDeleted';
export * from '../models/V1CampaignEvent';
export * from '../models/V1CampaignFlightDatesSet';
export * from '../models/V1CampaignJobIdSet';
export * from '../models/V1CampaignNameSet';
export * from '../models/V1CampaignOrderLine';
export * from '../models/V1CampaignPoIdSet';
export * from '../models/V1CampaignPoliticalIndependentExpenditureFormPathSet';
export * from '../models/V1CampaignPoliticalIndependentExpenditureStateSet';
export * from '../models/V1CampaignPoliticalTransparencySet';
export * from '../models/V1CampaignRefIDSet';
export * from '../models/V1CampaignSearch';
export * from '../models/V1CampaignUnarchived';
export * from '../models/V1CancelAudienceGenerationRequest';
export * from '../models/V1ClientRoles';
export * from '../models/V1CloneAudienceRequest';
export * from '../models/V1CombinationRule';
export * from '../models/V1CommissionType';
export * from '../models/V1ComponentResult';
export * from '../models/V1ComponentResults';
export * from '../models/V1CostRange';
export * from '../models/V1CpmPlus';
export * from '../models/V1CreateEmailMappingRequest';
export * from '../models/V1CreateReportResponse';
export * from '../models/V1CreateRouteRequest';
export * from '../models/V1CreativeAdded';
export * from '../models/V1CreativeFile';
export * from '../models/V1CreativeFileMetadata';
export * from '../models/V1CreativeRemoved';
export * from '../models/V1CreativeSearch';
export * from '../models/V1CredentialRepresentation';
export * from '../models/V1CreditCard';
export * from '../models/V1CronResponse';
export * from '../models/V1CsvExportConfig';
export * from '../models/V1DataProduct';
export * from '../models/V1DataSource';
export * from '../models/V1DataSourcesHighestUpcharge';
export * from '../models/V1DayOfWeek';
export * from '../models/V1DeployMetadata';
export * from '../models/V1DestinationAllocation';
export * from '../models/V1DetachExcludedAddressesRequest';
export * from '../models/V1DeviceMainDetails';
export * from '../models/V1DeviceResultIDs';
export * from '../models/V1DeviceResults';
export * from '../models/V1DeviceStatsResponse';
export * from '../models/V1DeviceSubDetails';
export * from '../models/V1Distribution';
export * from '../models/V1DownloadAudienceFileResponse';
export * from '../models/V1DownloadBundleResponse';
export * from '../models/V1DownloadCreativeFileResponse';
export * from '../models/V1DownloadExclusionAddressesResponse';
export * from '../models/V1DownloadJobFileResponse';
export * from '../models/V1DownloadTOSAgreementResponse';
export * from '../models/V1EmailDestinations';
export * from '../models/V1EmailMapping';
export * from '../models/V1EmailTemplateConfig';
export * from '../models/V1Entry';
export * from '../models/V1Excludes';
export * from '../models/V1ExclusionAddresses';
export * from '../models/V1ExclusionAddressesAttached';
export * from '../models/V1ExclusionAddressesDetached';
export * from '../models/V1ExclusionAddressesFileMetaData';
export * from '../models/V1ExportConfig';
export * from '../models/V1ExportDataResponse';
export * from '../models/V1ExportType';
export * from '../models/V1FTP';
export * from '../models/V1FileFilters';
export * from '../models/V1FileSubType';
export * from '../models/V1FrequencyConfig';
export * from '../models/V1GetNewMoverMatchCountResponse';
export * from '../models/V1GetNotificationsResponse';
export * from '../models/V1GetTemplateResponse';
export * from '../models/V1GetUserIPResponse';
export * from '../models/V1GlobalSearchResponse';
export * from '../models/V1HighestCPMAudience';
export * from '../models/V1Includes';
export * from '../models/V1IntervalUnit';
export * from '../models/V1JWT';
export * from '../models/V1Job';
export * from '../models/V1JobFileType';
export * from '../models/V1JobSearch';
export * from '../models/V1JobSubType';
export * from '../models/V1JobTemplate';
export * from '../models/V1JobType';
export * from '../models/V1ListAccountingJobsResponse';
export * from '../models/V1ListAssetsResponse';
export * from '../models/V1ListAudienceFoldersResponse';
export * from '../models/V1ListAudiencesResponse';
export * from '../models/V1ListCampaignEventsResponse';
export * from '../models/V1ListCommissionGroupsResponse';
export * from '../models/V1ListCreativeFoldersResponse';
export * from '../models/V1ListCreditCardsResponse';
export * from '../models/V1ListEmailMappingsResponse';
export * from '../models/V1ListExclusionAddressesResponse';
export * from '../models/V1ListOfString';
export * from '../models/V1ListOrderLineEventsResponse';
export * from '../models/V1ListOrderLineJobsResponse';
export * from '../models/V1ListOrderLinesResponse';
export * from '../models/V1ListOrgSubscriptionsResponse';
export * from '../models/V1ListOrgUsersResponse';
export * from '../models/V1ListOrgsResponse';
export * from '../models/V1ListPixelsResponse';
export * from '../models/V1ListPublisherSubscriptionsResponse';
export * from '../models/V1ListPublishersResponse';
export * from '../models/V1ListReportRunsResponse';
export * from '../models/V1ListReportsResponse';
export * from '../models/V1ListRoutesResponse';
export * from '../models/V1ListRulesResponse';
export * from '../models/V1ListSchedulesResponse';
export * from '../models/V1ListStatsResponse';
export * from '../models/V1ListSubscriptionsResponse';
export * from '../models/V1ListTOSAgreementsResponse';
export * from '../models/V1ListTotalStatsResponse';
export * from '../models/V1MainDetails';
export * from '../models/V1MatchMode';
export * from '../models/V1MatchScope';
export * from '../models/V1Medium';
export * from '../models/V1Message';
export * from '../models/V1MessageType';
export * from '../models/V1Metrics';
export * from '../models/V1MetricsGranularity';
export * from '../models/V1MonthlyFrequencyConfig';
export * from '../models/V1MoverMatchCount';
export * from '../models/V1Notification';
export * from '../models/V1OAuthTokenRequest';
export * from '../models/V1OrderLineAdTypeSet';
export * from '../models/V1OrderLineApproved';
export * from '../models/V1OrderLineArchived';
export * from '../models/V1OrderLineAuditConditionsSet';
export * from '../models/V1OrderLineCPMOverrideRemoved';
export * from '../models/V1OrderLineCPMOverriden';
export * from '../models/V1OrderLineCPMSet';
export * from '../models/V1OrderLineCampaign';
export * from '../models/V1OrderLineClickThroughURLSet';
export * from '../models/V1OrderLineCloneRequestFailed';
export * from '../models/V1OrderLineCloneRequestSucceeded';
export * from '../models/V1OrderLineCloned';
export * from '../models/V1OrderLineCompleted';
export * from '../models/V1OrderLineCostSet';
export * from '../models/V1OrderLineCreated';
export * from '../models/V1OrderLineDeleted';
export * from '../models/V1OrderLineDeployed';
export * from '../models/V1OrderLineDeployedToDestinationRTB';
export * from '../models/V1OrderLineDeployedToDestinationStackAdapt';
export * from '../models/V1OrderLineDeployedToDestinationXandrCurate';
export * from '../models/V1OrderLineDeployedToDestinationXandrInvest';
export * from '../models/V1OrderLineDeployedWithConfig';
export * from '../models/V1OrderLineDeploymentCancelled';
export * from '../models/V1OrderLineDeploymentCancelling';
export * from '../models/V1OrderLineDeploymentDestinationSet';
export * from '../models/V1OrderLineDestinationRTBCreated';
export * from '../models/V1OrderLineDestinationRTBSet';
export * from '../models/V1OrderLineDestinationStackAdaptCreated';
export * from '../models/V1OrderLineDestinationStackAdaptSet';
export * from '../models/V1OrderLineDestinationXandrCurateCreated';
export * from '../models/V1OrderLineDestinationXandrCurateSet';
export * from '../models/V1OrderLineDestinationXandrInvestCreated';
export * from '../models/V1OrderLineDestinationXandrInvestSet';
export * from '../models/V1OrderLineDistributionSet';
export * from '../models/V1OrderLineEndTimeSet';
export * from '../models/V1OrderLineErroredDeployingToDestinationRTB';
export * from '../models/V1OrderLineErroredDeployingToDestinationStackAdapt';
export * from '../models/V1OrderLineErroredDeployingToDestinationXandrCurate';
export * from '../models/V1OrderLineErroredDeployingToDestinationXandrInvest';
export * from '../models/V1OrderLineEvent';
export * from '../models/V1OrderLineFreeImpressionsSet';
export * from '../models/V1OrderLineImpressionsPerDaySet';
export * from '../models/V1OrderLineImpressionsSet';
export * from '../models/V1OrderLineJob';
export * from '../models/V1OrderLineJobIdSet';
export * from '../models/V1OrderLineLocked';
export * from '../models/V1OrderLineMigrated';
export * from '../models/V1OrderLineMinimumImpressionsSet';
export * from '../models/V1OrderLineNameSet';
export * from '../models/V1OrderLineNoteAppended';
export * from '../models/V1OrderLineNoteDeactivated';
export * from '../models/V1OrderLineNoteUpdated';
export * from '../models/V1OrderLinePaidSet';
export * from '../models/V1OrderLinePaused';
export * from '../models/V1OrderLinePlayed';
export * from '../models/V1OrderLinePoIdSet';
export * from '../models/V1OrderLinePoliticalFieldsSet';
export * from '../models/V1OrderLinePrepaySet';
export * from '../models/V1OrderLineRedeployVerificationFailed';
export * from '../models/V1OrderLineRefIdSet';
export * from '../models/V1OrderLineRejected';
export * from '../models/V1OrderLineReviewStarted';
export * from '../models/V1OrderLineSearch';
export * from '../models/V1OrderLineSegmentConfigSet';
export * from '../models/V1OrderLineStartTimeSet';
export * from '../models/V1OrderLineStateSetToActive';
export * from '../models/V1OrderLineStateSetToPaused';
export * from '../models/V1OrderLineStatus';
export * from '../models/V1OrderLineStatusSetToDeploying';
export * from '../models/V1OrderLineStatusSetToDraft';
export * from '../models/V1OrderLineStatusSetToPrevious';
export * from '../models/V1OrderLineStepFunctionSet';
export * from '../models/V1OrderLineTemplateTypeSet';
export * from '../models/V1OrderLineUnarchived';
export * from '../models/V1OrderLineUnlocked';
export * from '../models/V1OrderLineViantAdelphicConfigurationSet';
export * from '../models/V1OrderLineViantAdelphicIDsSet';
export * from '../models/V1OrderLineViantAdelphicIDsSetCreativeID';
export * from '../models/V1OrgData';
export * from '../models/V1OrgLogo';
export * from '../models/V1PayOrderLinesRequest';
export * from '../models/V1PdfExportConfig';
export * from '../models/V1Pixel';
export * from '../models/V1PixelCreated';
export * from '../models/V1PixelNote';
export * from '../models/V1PixelUpdated';
export * from '../models/V1PoliticalFields';
export * from '../models/V1PoliticalTransparency';
export * from '../models/V1ProductType';
export * from '../models/V1Publisher';
export * from '../models/V1PublisherSubscription';
export * from '../models/V1QueueDetails';
export * from '../models/V1QueueHealth';
export * from '../models/V1RebuildGlobalSearchRequest';
export * from '../models/V1RebuildGlobalSearchResourceType';
export * from '../models/V1Report';
export * from '../models/V1ReportGranularity';
export * from '../models/V1ReportRun';
export * from '../models/V1ReportRunStatus';
export * from '../models/V1ReportType';
export * from '../models/V1RequestOrgNameChangeRequest';
export * from '../models/V1RequestSupportRequest';
export * from '../models/V1Result';
export * from '../models/V1ResultIDs';
export * from '../models/V1ResultMetrics';
export * from '../models/V1Results';
export * from '../models/V1ReviewRequested';
export * from '../models/V1Route';
export * from '../models/V1RouteJobReport';
export * from '../models/V1Rule';
export * from '../models/V1RuleSet';
export * from '../models/V1RunCommissionsRequest';
export * from '../models/V1RunCommissionsResponse';
export * from '../models/V1RunInvoicingRequest';
export * from '../models/V1RunInvoicingResponse';
export * from '../models/V1Schedule';
export * from '../models/V1ScheduleFrequency';
export * from '../models/V1ScheduleStatus';
export * from '../models/V1SendMessageRequest';
export * from '../models/V1SetCampaignPoliticalFormRequest';
export * from '../models/V1SlackTemplateConfig';
export * from '../models/V1State';
export * from '../models/V1Stats';
export * from '../models/V1StatsResponse';
export * from '../models/V1StringList';
export * from '../models/V1SubDetails';
export * from '../models/V1Subscription';
export * from '../models/V1SubscriptionCreated';
export * from '../models/V1SubscriptionNote';
export * from '../models/V1SubscriptionUpdated';
export * from '../models/V1TOSAgreement';
export * from '../models/V1TargetJobSearch';
export * from '../models/V1TargetSearch';
export * from '../models/V1TemplateConfigType';
export * from '../models/V1TemplateReport';
export * from '../models/V1TemplateType';
export * from '../models/V1TemplateVariableValue';
export * from '../models/V1TimeframePreset';
export * from '../models/V1TriggerRouteResponse';
export * from '../models/V1UnarchiveCreativeRequest';
export * from '../models/V1UnarchiveOrderLineRequest';
export * from '../models/V1Upcharge';
export * from '../models/V1UpdateOrderLineRequest';
export * from '../models/V1UpdateOrgRequest';
export * from '../models/V1UploadAssetMetadata';
export * from '../models/V1UploadAssetRequest';
export * from '../models/V1UploadCreativeFileRequest';
export * from '../models/V1UploadExclusionAddressesRequest';
export * from '../models/V1UploadOrderLineJobRequest';
export * from '../models/V1UploadOrgLogoMetadata';
export * from '../models/V1UploadTOSAgreementRequest';
export * from '../models/V1WebToHomeEvent';
export * from '../models/V1WebToHomeNoteType';
export * from '../models/V1WeeklyFrequencyConfig';
export * from '../models/V2ArchiveTargetRequest';
export * from '../models/V2CreateJsonTargetRequest';
export * from '../models/V2DownloadTargetFileResponse';
export * from '../models/V2ListTargetFoldersResponse';
export * from '../models/V2ListTargetsResponse';
export * from '../models/V2ReplaceFileMetaData';
export * from '../models/V2ReplaceTargetFileRequest';
export * from '../models/V2Target';
export * from '../models/V2TargetJob';
export * from '../models/V2TargetStatus';
export * from '../models/V2UnarchiveTargetRequest';
export * from '../models/V2UploadTargetFileRequest';
export * from '../models/V3Advertiser';
export * from '../models/V3AuctionEvent';
export * from '../models/V3AugmentedLineItem';
export * from '../models/V3BrowserTarget';
export * from '../models/V3BudgetInterval';
export * from '../models/V3BudgetSchedulingSettings';
export * from '../models/V3BuyerSeat';
export * from '../models/V3CampaignCreative';
export * from '../models/V3CampaignDeviceCaps';
export * from '../models/V3Condition';
export * from '../models/V3ConsoleCampaign';
export * from '../models/V3ContextualTargeting';
export * from '../models/V3CountryTarget';
export * from '../models/V3CreativeType';
export * from '../models/V3CurateCampaign';
export * from '../models/V3CustomDateRange';
export * from '../models/V3DaypartTarget';
export * from '../models/V3Deal';
export * from '../models/V3DealConfig';
export * from '../models/V3DealList';
export * from '../models/V3DealType';
export * from '../models/V3DeploySegmentsToCurateRequest';
export * from '../models/V3DeploymentDestinationConfigurations';
export * from '../models/V3DirectMailCampaign';
export * from '../models/V3DirectMailConfiguration';
export * from '../models/V3DomainListTarget';
export * from '../models/V3EngagementRateTarget';
export * from '../models/V3GenericDeployRequest';
export * from '../models/V3GovernmentLevel';
export * from '../models/V3InventoryAttributeTarget';
export * from '../models/V3InventoryListTarget';
export * from '../models/V3InvestCampaign';
export * from '../models/V3Language';
export * from '../models/V3LanguageTarget';
export * from '../models/V3LegacyCampaign';
export * from '../models/V3LineItem';
export * from '../models/V3LineItemDeal';
export * from '../models/V3LineItemPixel';
export * from '../models/V3ListAdvertisersResponse';
export * from '../models/V3ListDeploymentsResponse';
export * from '../models/V3ListSegmentsResponse';
export * from '../models/V3ListXandrDealListsResponse';
export * from '../models/V3ListXandrDealsResponse';
export * from '../models/V3ListXandrLanguagesResponse';
export * from '../models/V3ListXandrRegionsResponse';
export * from '../models/V3MemberDataSharing';
export * from '../models/V3MemberDataSharingSegment';
export * from '../models/V3NonSeamlessInsertionOrder';
export * from '../models/V3PacingStrategies';
export * from '../models/V3PoliticalContent';
export * from '../models/V3Position';
export * from '../models/V3PositionTargets';
export * from '../models/V3Profile';
export * from '../models/V3QueueRequest';
export * from '../models/V3RTBCampaign';
export * from '../models/V3RTBConfiguration';
export * from '../models/V3RTBCreativeMap';
export * from '../models/V3RTBCreativeMapping';
export * from '../models/V3RTBOrderLine';
export * from '../models/V3RTBOrderLineUpdateStatus';
export * from '../models/V3Region';
export * from '../models/V3RegionTarget';
export * from '../models/V3RegistrationForm';
export * from '../models/V3ResolveSegmentorIncidentResponse';
export * from '../models/V3SGSegment';
export * from '../models/V3SeamlessInsertionOrder';
export * from '../models/V3Segment';
export * from '../models/V3SegmentConfig';
export * from '../models/V3SegmentGroupTarget';
export * from '../models/V3SegmentType';
export * from '../models/V3SegmentorDeploymentResults';
export * from '../models/V3Split';
export * from '../models/V3StackAdaptAd';
export * from '../models/V3StackAdaptAudience';
export * from '../models/V3StackAdaptBidFactor';
export * from '../models/V3StackAdaptCampaign';
export * from '../models/V3StackAdaptCampaignConfig';
export * from '../models/V3StackAdaptCampaignFlight';
export * from '../models/V3StackAdaptCampaignGoal';
export * from '../models/V3StackAdaptCampaignGroupConfig';
export * from '../models/V3StackAdaptCampaignUpdateStatus';
export * from '../models/V3StackAdaptConfiguration';
export * from '../models/V3StackAdaptCreative';
export * from '../models/V3StackAdaptCreativeAdMapping';
export * from '../models/V3StackAdaptCreativeAdMappingStatus';
export * from '../models/V3StackAdaptCreativeMap';
export * from '../models/V3StackAdaptCreativeMapping';
export * from '../models/V3StackAdaptCreativeTactic';
export * from '../models/V3StackAdaptCreativeTag';
export * from '../models/V3StackAdaptDayOption';
export * from '../models/V3StackAdaptDayOptions';
export * from '../models/V3StackAdaptDayParting';
export * from '../models/V3StackAdaptDeviceTypeRule';
export * from '../models/V3StackAdaptFlight';
export * from '../models/V3StackAdaptGeoTargeting';
export * from '../models/V3StackAdaptGlobalZipTargeting';
export * from '../models/V3StackAdaptGoal';
export * from '../models/V3StackAdaptHourlyParting';
export * from '../models/V3StackAdaptInventoryConfig';
export * from '../models/V3StackAdaptLibraryAd';
export * from '../models/V3StackAdaptSegmentMap';
export * from '../models/V3StackAdaptSegmentMapping';
export * from '../models/V3StackAdaptTacticAd';
export * from '../models/V3StackAdaptTacticCustomSegmentRule';
export * from '../models/V3StackAdaptTacticDateRule';
export * from '../models/V3StackAdaptTacticDayTimeRule';
export * from '../models/V3StackAdaptTacticLanguageRule';
export * from '../models/V3StackAdaptTacticWeekDayRule';
export * from '../models/V3StackAdaptTimeSlot';
export * from '../models/V3StackAdaptUserMetadata';
export * from '../models/V3StackAdaptVastMedia';
export * from '../models/V3StackAdaptVastMediaData';
export * from '../models/V3StackAdaptVastTracker';
export * from '../models/V3StackAdaptWeekdayParting';
export * from '../models/V3StartSegmentorIncidentRequest';
export * from '../models/V3StartSegmentorIncidentResponse';
export * from '../models/V3SupplyStrategies';
export * from '../models/V3UserInfo';
export * from '../models/V3Valuation';
export * from '../models/V3Values';
export * from '../models/V3ViantAdelphicConfiguration';
export * from '../models/V3ViantCreativeConfig';
export * from '../models/V3ViantSegmentConfig';
export * from '../models/V3XandrConsoleConfiguration';
export * from '../models/V3XandrCurateConfiguration';
export * from '../models/V3XandrInvestConfiguration';

import { AddAudienceRequest } from '../models/AddAudienceRequest';
import { AddCreativeRequest } from '../models/AddCreativeRequest';
import { AdvertisingPlatformServiceAddAccountRepRequest } from '../models/AdvertisingPlatformServiceAddAccountRepRequest';
import { AdvertisingPlatformServiceAddCommissionGroupRequest } from '../models/AdvertisingPlatformServiceAddCommissionGroupRequest';
import { AdvertisingPlatformServiceAddSalesRepRequest } from '../models/AdvertisingPlatformServiceAddSalesRepRequest';
import { AdvertisingPlatformServiceAddUserRequest } from '../models/AdvertisingPlatformServiceAddUserRequest';
import { AdvertisingPlatformServiceAppendOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceAppendOrderLineNoteRequest';
import { AdvertisingPlatformServiceBatchAddAudiencesRequest } from '../models/AdvertisingPlatformServiceBatchAddAudiencesRequest';
import { AdvertisingPlatformServiceBatchAddCreativesRequest } from '../models/AdvertisingPlatformServiceBatchAddCreativesRequest';
import { AdvertisingPlatformServiceBatchRemoveAudiencesRequest } from '../models/AdvertisingPlatformServiceBatchRemoveAudiencesRequest';
import { AdvertisingPlatformServiceBatchRemoveCreativesRequest } from '../models/AdvertisingPlatformServiceBatchRemoveCreativesRequest';
import { AdvertisingPlatformServiceCloneOrderLineRequest } from '../models/AdvertisingPlatformServiceCloneOrderLineRequest';
import { AdvertisingPlatformServiceCreateOrgNoteRequest } from '../models/AdvertisingPlatformServiceCreateOrgNoteRequest';
import { AdvertisingPlatformServiceDeactivateOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceDeactivateOrderLineNoteRequest';
import { AdvertisingPlatformServicePauseSchedulesRequest } from '../models/AdvertisingPlatformServicePauseSchedulesRequest';
import { AdvertisingPlatformServicePlaySchedulesRequest } from '../models/AdvertisingPlatformServicePlaySchedulesRequest';
import { AdvertisingPlatformServiceRemoveCommissionGroupRequest } from '../models/AdvertisingPlatformServiceRemoveCommissionGroupRequest';
import { AdvertisingPlatformServiceRemoveUserRequest } from '../models/AdvertisingPlatformServiceRemoveUserRequest';
import { AdvertisingPlatformServiceRetryReportRunRequest } from '../models/AdvertisingPlatformServiceRetryReportRunRequest';
import { AdvertisingPlatformServiceRunOneSubscriptionRequest } from '../models/AdvertisingPlatformServiceRunOneSubscriptionRequest';
import { AdvertisingPlatformServiceRunReportRequest } from '../models/AdvertisingPlatformServiceRunReportRequest';
import { AdvertisingPlatformServiceTriggerRouteRequest } from '../models/AdvertisingPlatformServiceTriggerRouteRequest';
import { AdvertisingPlatformServiceUpdateAssetRequest } from '../models/AdvertisingPlatformServiceUpdateAssetRequest';
import { AdvertisingPlatformServiceUpdateEmailMappingRequest } from '../models/AdvertisingPlatformServiceUpdateEmailMappingRequest';
import { AdvertisingPlatformServiceUpdateFTPRequest } from '../models/AdvertisingPlatformServiceUpdateFTPRequest';
import { AdvertisingPlatformServiceUpdateOrderLineNoteRequest } from '../models/AdvertisingPlatformServiceUpdateOrderLineNoteRequest';
import { AdvertisingPlatformServiceUpdatePixelRequest } from '../models/AdvertisingPlatformServiceUpdatePixelRequest';
import { AdvertisingPlatformServiceUpdatePublisherRequest } from '../models/AdvertisingPlatformServiceUpdatePublisherRequest';
import { AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest } from '../models/AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest';
import { AdvertisingPlatformServiceUpdateRouteRequest } from '../models/AdvertisingPlatformServiceUpdateRouteRequest';
import { AdvertisingPlatformServiceUpdateRuleRequest } from '../models/AdvertisingPlatformServiceUpdateRuleRequest';
import { AdvertisingPlatformServiceUpdateRuleSetRequest } from '../models/AdvertisingPlatformServiceUpdateRuleSetRequest';
import { AdvertisingPlatformServiceUpdateSubscriptionRequest } from '../models/AdvertisingPlatformServiceUpdateSubscriptionRequest';
import { ApproveOrderLineRequest } from '../models/ApproveOrderLineRequest';
import { Apqsv1Checks } from '../models/Apqsv1Checks';
import { Apqsv1Dependency } from '../models/Apqsv1Dependency';
import { Apqsv1HealthCheck } from '../models/Apqsv1HealthCheck';
import { Apqsv1HealthCondition } from '../models/Apqsv1HealthCondition';
import { Apqsv1Miscellanea } from '../models/Apqsv1Miscellanea';
import { Apqsv1SystemStat } from '../models/Apqsv1SystemStat';
import { Billingservicev1Checks } from '../models/Billingservicev1Checks';
import { Billingservicev1CommissionGroup } from '../models/Billingservicev1CommissionGroup';
import { Billingservicev1Dependency } from '../models/Billingservicev1Dependency';
import { Billingservicev1HealthCheck } from '../models/Billingservicev1HealthCheck';
import { Billingservicev1HealthCondition } from '../models/Billingservicev1HealthCondition';
import { Billingservicev1Invoice } from '../models/Billingservicev1Invoice';
import { Billingservicev1InvoiceStatus } from '../models/Billingservicev1InvoiceStatus';
import { Billingservicev1ListInvoicesResponse } from '../models/Billingservicev1ListInvoicesResponse';
import { Billingservicev1Miscellanea } from '../models/Billingservicev1Miscellanea';
import { Billingservicev1Org } from '../models/Billingservicev1Org';
import { Billingservicev1SystemStat } from '../models/Billingservicev1SystemStat';
import { Billingservicev2Invoice } from '../models/Billingservicev2Invoice';
import { Billingservicev2InvoiceStatus } from '../models/Billingservicev2InvoiceStatus';
import { Billingservicev2ListInvoicesResponse } from '../models/Billingservicev2ListInvoicesResponse';
import { CPMContainsInformationRelatingToAClientCpmanization } from '../models/CPMContainsInformationRelatingToAClientCpmanization';
import { Campaignservicev1AdType } from '../models/Campaignservicev1AdType';
import { Campaignservicev1Audience } from '../models/Campaignservicev1Audience';
import { Campaignservicev1Campaign } from '../models/Campaignservicev1Campaign';
import { Campaignservicev1Checks } from '../models/Campaignservicev1Checks';
import { Campaignservicev1Creative } from '../models/Campaignservicev1Creative';
import { Campaignservicev1Dependency } from '../models/Campaignservicev1Dependency';
import { Campaignservicev1HealthCheck } from '../models/Campaignservicev1HealthCheck';
import { Campaignservicev1HealthCondition } from '../models/Campaignservicev1HealthCondition';
import { Campaignservicev1JobStatus } from '../models/Campaignservicev1JobStatus';
import { Campaignservicev1ListCampaignsResponse } from '../models/Campaignservicev1ListCampaignsResponse';
import { Campaignservicev1Miscellanea } from '../models/Campaignservicev1Miscellanea';
import { Campaignservicev1Note } from '../models/Campaignservicev1Note';
import { Campaignservicev1NoteType } from '../models/Campaignservicev1NoteType';
import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { Campaignservicev1Status } from '../models/Campaignservicev1Status';
import { Campaignservicev1SystemStat } from '../models/Campaignservicev1SystemStat';
import { CancelOrderLineDeploymentRequest } from '../models/CancelOrderLineDeploymentRequest';
import { Contact } from '../models/Contact';
import { CreateCreditCardRequest } from '../models/CreateCreditCardRequest';
import { CreateDeploymentRequest } from '../models/CreateDeploymentRequest';
import { Creativeservicev1AdType } from '../models/Creativeservicev1AdType';
import { Creativeservicev1Audit } from '../models/Creativeservicev1Audit';
import { Creativeservicev1AuditResult } from '../models/Creativeservicev1AuditResult';
import { Creativeservicev1AuditStatus } from '../models/Creativeservicev1AuditStatus';
import { Creativeservicev1Checks } from '../models/Creativeservicev1Checks';
import { Creativeservicev1Creative } from '../models/Creativeservicev1Creative';
import { Creativeservicev1Dependency } from '../models/Creativeservicev1Dependency';
import { Creativeservicev1DeploymentType } from '../models/Creativeservicev1DeploymentType';
import { Creativeservicev1Destination } from '../models/Creativeservicev1Destination';
import { Creativeservicev1FileType } from '../models/Creativeservicev1FileType';
import { Creativeservicev1FolderStats } from '../models/Creativeservicev1FolderStats';
import { Creativeservicev1HealthCheck } from '../models/Creativeservicev1HealthCheck';
import { Creativeservicev1HealthCondition } from '../models/Creativeservicev1HealthCondition';
import { Creativeservicev1ListCreativesResponse } from '../models/Creativeservicev1ListCreativesResponse';
import { Creativeservicev1Miscellanea } from '../models/Creativeservicev1Miscellanea';
import { Creativeservicev1NativeMetadata } from '../models/Creativeservicev1NativeMetadata';
import { Creativeservicev1OrderLine } from '../models/Creativeservicev1OrderLine';
import { Creativeservicev1Status } from '../models/Creativeservicev1Status';
import { Creativeservicev1SystemStat } from '../models/Creativeservicev1SystemStat';
import { Creativeservicev1Type } from '../models/Creativeservicev1Type';
import { CreditCard } from '../models/CreditCard';
import { CreditCard1 } from '../models/CreditCard1';
import { DeployMetadataDeployedCPM } from '../models/DeployMetadataDeployedCPM';
import { DeployOrderLineRequest } from '../models/DeployOrderLineRequest';
import { Deployservicev3Audit } from '../models/Deployservicev3Audit';
import { Deployservicev3AuditResult } from '../models/Deployservicev3AuditResult';
import { Deployservicev3AuditStatus } from '../models/Deployservicev3AuditStatus';
import { Deployservicev3Campaign } from '../models/Deployservicev3Campaign';
import { Deployservicev3Checks } from '../models/Deployservicev3Checks';
import { Deployservicev3Creative } from '../models/Deployservicev3Creative';
import { Deployservicev3CreativeID } from '../models/Deployservicev3CreativeID';
import { Deployservicev3Dependency } from '../models/Deployservicev3Dependency';
import { Deployservicev3Deployment } from '../models/Deployservicev3Deployment';
import { Deployservicev3DeploymentType } from '../models/Deployservicev3DeploymentType';
import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { Deployservicev3HealthCheck } from '../models/Deployservicev3HealthCheck';
import { Deployservicev3HealthCondition } from '../models/Deployservicev3HealthCondition';
import { Deployservicev3ListCampaignsResponse } from '../models/Deployservicev3ListCampaignsResponse';
import { Deployservicev3ListCreativesResponse } from '../models/Deployservicev3ListCreativesResponse';
import { Deployservicev3Miscellanea } from '../models/Deployservicev3Miscellanea';
import { Deployservicev3NativeMetadata } from '../models/Deployservicev3NativeMetadata';
import { Deployservicev3Status } from '../models/Deployservicev3Status';
import { Deployservicev3SystemStat } from '../models/Deployservicev3SystemStat';
import { Deployservicev3Value } from '../models/Deployservicev3Value';
import { DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries } from '../models/DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries';
import { ExistingUserWithNewFieldValues } from '../models/ExistingUserWithNewFieldValues';
import { GetDefaultTemplateRequest } from '../models/GetDefaultTemplateRequest';
import { GlobalSearchResponseCount } from '../models/GlobalSearchResponseCount';
import { GoogleprotobufAny } from '../models/GoogleprotobufAny';
import { GooglerpcStatus } from '../models/GooglerpcStatus';
import { Hagridv1Checks } from '../models/Hagridv1Checks';
import { Hagridv1Dependency } from '../models/Hagridv1Dependency';
import { Hagridv1FileMetaData } from '../models/Hagridv1FileMetaData';
import { Hagridv1HealthCheck } from '../models/Hagridv1HealthCheck';
import { Hagridv1HealthCondition } from '../models/Hagridv1HealthCondition';
import { Hagridv1ListUsersResponse } from '../models/Hagridv1ListUsersResponse';
import { Hagridv1Miscellanea } from '../models/Hagridv1Miscellanea';
import { Hagridv1SystemStat } from '../models/Hagridv1SystemStat';
import { Hagridv1User } from '../models/Hagridv1User';
import { Job } from '../models/Job';
import { LockOrderLineRequest } from '../models/LockOrderLineRequest';
import { MoveOrgsRequest } from '../models/MoveOrgsRequest';
import { Notification } from '../models/Notification';
import { Notificationservicev1Checks } from '../models/Notificationservicev1Checks';
import { Notificationservicev1Dependency } from '../models/Notificationservicev1Dependency';
import { Notificationservicev1HealthCheck } from '../models/Notificationservicev1HealthCheck';
import { Notificationservicev1HealthCondition } from '../models/Notificationservicev1HealthCondition';
import { Notificationservicev1Miscellanea } from '../models/Notificationservicev1Miscellanea';
import { Notificationservicev1SystemStat } from '../models/Notificationservicev1SystemStat';
import { Notificationservicev1Type } from '../models/Notificationservicev1Type';
import { OrderLineJobErrorDetail } from '../models/OrderLineJobErrorDetail';
import { OrderLineViantAdelphicIDsSetAudienceID } from '../models/OrderLineViantAdelphicIDsSetAudienceID';
import { Orgmanagerv1Checks } from '../models/Orgmanagerv1Checks';
import { Orgmanagerv1CommissionGroup } from '../models/Orgmanagerv1CommissionGroup';
import { Orgmanagerv1Contact } from '../models/Orgmanagerv1Contact';
import { Orgmanagerv1Dependency } from '../models/Orgmanagerv1Dependency';
import { Orgmanagerv1HealthCheck } from '../models/Orgmanagerv1HealthCheck';
import { Orgmanagerv1HealthCondition } from '../models/Orgmanagerv1HealthCondition';
import { Orgmanagerv1Miscellanea } from '../models/Orgmanagerv1Miscellanea';
import { Orgmanagerv1Note } from '../models/Orgmanagerv1Note';
import { Orgmanagerv1NoteType } from '../models/Orgmanagerv1NoteType';
import { Orgmanagerv1Org } from '../models/Orgmanagerv1Org';
import { Orgmanagerv1Status } from '../models/Orgmanagerv1Status';
import { Orgmanagerv1SystemStat } from '../models/Orgmanagerv1SystemStat';
import { Orgmanagerv1Timeframe } from '../models/Orgmanagerv1Timeframe';
import { Orgmanagerv1User } from '../models/Orgmanagerv1User';
import { Orgmanagerv2ListUsersResponse } from '../models/Orgmanagerv2ListUsersResponse';
import { Orgmanagerv2User } from '../models/Orgmanagerv2User';
import { PauseOrderLineRequest } from '../models/PauseOrderLineRequest';
import { PayInvoiceRequest } from '../models/PayInvoiceRequest';
import { PaySetUpFeeRequest } from '../models/PaySetUpFeeRequest';
import { PixelNote } from '../models/PixelNote';
import { PlayOrderLineRequest } from '../models/PlayOrderLineRequest';
import { PrepayRequest } from '../models/PrepayRequest';
import { ProtobufNullValue } from '../models/ProtobufNullValue';
import { RejectOrderLineRequest } from '../models/RejectOrderLineRequest';
import { RemoveAudienceRequest } from '../models/RemoveAudienceRequest';
import { RemoveCreativeRequest } from '../models/RemoveCreativeRequest';
import { RequestReviewRequest } from '../models/RequestReviewRequest';
import { SetDistributionRequest } from '../models/SetDistributionRequest';
import { StartReviewRequest } from '../models/StartReviewRequest';
import { StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries } from '../models/StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries';
import { StreamResultOfV1DownloadAudienceFileResponse } from '../models/StreamResultOfV1DownloadAudienceFileResponse';
import { StreamResultOfV1DownloadBundleResponse } from '../models/StreamResultOfV1DownloadBundleResponse';
import { StreamResultOfV1DownloadCreativeFileResponse } from '../models/StreamResultOfV1DownloadCreativeFileResponse';
import { StreamResultOfV1DownloadExclusionAddressesResponse } from '../models/StreamResultOfV1DownloadExclusionAddressesResponse';
import { StreamResultOfV1DownloadJobFileResponse } from '../models/StreamResultOfV1DownloadJobFileResponse';
import { StreamResultOfV1DownloadTOSAgreementResponse } from '../models/StreamResultOfV1DownloadTOSAgreementResponse';
import { StreamResultOfV2DownloadTargetFileResponse } from '../models/StreamResultOfV2DownloadTargetFileResponse';
import { SubscriptionNote } from '../models/SubscriptionNote';
import { Targetjobservicev1Audience } from '../models/Targetjobservicev1Audience';
import { Targetjobservicev1Checks } from '../models/Targetjobservicev1Checks';
import { Targetjobservicev1Column } from '../models/Targetjobservicev1Column';
import { Targetjobservicev1Dependency } from '../models/Targetjobservicev1Dependency';
import { Targetjobservicev1Deployment } from '../models/Targetjobservicev1Deployment';
import { Targetjobservicev1FolderStats } from '../models/Targetjobservicev1FolderStats';
import { Targetjobservicev1HealthCheck } from '../models/Targetjobservicev1HealthCheck';
import { Targetjobservicev1HealthCondition } from '../models/Targetjobservicev1HealthCondition';
import { Targetjobservicev1JobStatus } from '../models/Targetjobservicev1JobStatus';
import { Targetjobservicev1Miscellanea } from '../models/Targetjobservicev1Miscellanea';
import { Targetjobservicev1Note } from '../models/Targetjobservicev1Note';
import { Targetjobservicev1NoteType } from '../models/Targetjobservicev1NoteType';
import { Targetjobservicev1SystemStat } from '../models/Targetjobservicev1SystemStat';
import { Targetjobservicev1Timeframe } from '../models/Targetjobservicev1Timeframe';
import { Targetorchestratorv2Checks } from '../models/Targetorchestratorv2Checks';
import { Targetorchestratorv2Column } from '../models/Targetorchestratorv2Column';
import { Targetorchestratorv2Dependency } from '../models/Targetorchestratorv2Dependency';
import { Targetorchestratorv2FileMetaData } from '../models/Targetorchestratorv2FileMetaData';
import { Targetorchestratorv2FileType } from '../models/Targetorchestratorv2FileType';
import { Targetorchestratorv2FolderStats } from '../models/Targetorchestratorv2FolderStats';
import { Targetorchestratorv2HealthCheck } from '../models/Targetorchestratorv2HealthCheck';
import { Targetorchestratorv2HealthCondition } from '../models/Targetorchestratorv2HealthCondition';
import { Targetorchestratorv2Location } from '../models/Targetorchestratorv2Location';
import { Targetorchestratorv2Miscellanea } from '../models/Targetorchestratorv2Miscellanea';
import { Targetorchestratorv2SystemStat } from '../models/Targetorchestratorv2SystemStat';
import { TheAdvertiserToCreate } from '../models/TheAdvertiserToCreate';
import { TheAudienceToUpdate } from '../models/TheAudienceToUpdate';
import { TheAutomationToUpdate } from '../models/TheAutomationToUpdate';
import { TheCampaignToCreate } from '../models/TheCampaignToCreate';
import { TheCampaignToUpdate } from '../models/TheCampaignToUpdate';
import { TheCreativeToCreate } from '../models/TheCreativeToCreate';
import { TheCreativeToUpdate } from '../models/TheCreativeToUpdate';
import { TheDeploymentToCreate } from '../models/TheDeploymentToCreate';
import { TheNoteToUpdate } from '../models/TheNoteToUpdate';
import { TheOrderLineToUpdate } from '../models/TheOrderLineToUpdate';
import { TheOrganizationToUpdate } from '../models/TheOrganizationToUpdate';
import { TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask } from '../models/TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask';
import { TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask } from '../models/TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask';
import { TheSegmentToCreate } from '../models/TheSegmentToCreate';
import { TheTargetToUpdate } from '../models/TheTargetToUpdate';
import { TypeDate } from '../models/TypeDate';
import { TypeMoney } from '../models/TypeMoney';
import { UnlockOrderLineRequest } from '../models/UnlockOrderLineRequest';
import { UpdateCPMsRequest } from '../models/UpdateCPMsRequest';
import { UpdateDeploymentRequest } from '../models/UpdateDeploymentRequest';
import { V1AccountingJob } from '../models/V1AccountingJob';
import { V1AccountingJobKind } from '../models/V1AccountingJobKind';
import { V1AdditionalArguments } from '../models/V1AdditionalArguments';
import { V1AdminInvoice } from '../models/V1AdminInvoice';
import { V1AdminListNotificationsResponse } from '../models/V1AdminListNotificationsResponse';
import { V1ArchiveCampaignRequest } from '../models/V1ArchiveCampaignRequest';
import { V1ArchiveCreativeRequest } from '../models/V1ArchiveCreativeRequest';
import { V1ArchiveOrderLineRequest } from '../models/V1ArchiveOrderLineRequest';
import { V1Asset } from '../models/V1Asset';
import { V1AssetType } from '../models/V1AssetType';
import { V1Assignment } from '../models/V1Assignment';
import { V1AttachExcludedAddressesRequest } from '../models/V1AttachExcludedAddressesRequest';
import { V1Attachment } from '../models/V1Attachment';
import { V1AudienceAdded } from '../models/V1AudienceAdded';
import { V1AudienceFileType } from '../models/V1AudienceFileType';
import { V1AudienceRemoved } from '../models/V1AudienceRemoved';
import { V1AudienceStatus } from '../models/V1AudienceStatus';
import { V1AudienceSubType } from '../models/V1AudienceSubType';
import { V1AudienceType } from '../models/V1AudienceType';
import { V1AuditConditions } from '../models/V1AuditConditions';
import { V1Authorization } from '../models/V1Authorization';
import { V1Automation } from '../models/V1Automation';
import { V1AutomationType } from '../models/V1AutomationType';
import { V1AuxiliaryFileFilter } from '../models/V1AuxiliaryFileFilter';
import { V1Balance } from '../models/V1Balance';
import { V1BatchAddAudiencesRequestAudience } from '../models/V1BatchAddAudiencesRequestAudience';
import { V1BatchUpdateOrderLinesRequest } from '../models/V1BatchUpdateOrderLinesRequest';
import { V1BatchUpdateOrderLinesResponse } from '../models/V1BatchUpdateOrderLinesResponse';
import { V1BatchUpdateOrgsRequest } from '../models/V1BatchUpdateOrgsRequest';
import { V1BatchUpdateOrgsResponse } from '../models/V1BatchUpdateOrgsResponse';
import { V1BrandingMode } from '../models/V1BrandingMode';
import { V1BundleRequest } from '../models/V1BundleRequest';
import { V1CPM } from '../models/V1CPM';
import { V1CPMOverride } from '../models/V1CPMOverride';
import { V1CampaignArchived } from '../models/V1CampaignArchived';
import { V1CampaignCreated } from '../models/V1CampaignCreated';
import { V1CampaignDeleted } from '../models/V1CampaignDeleted';
import { V1CampaignEvent } from '../models/V1CampaignEvent';
import { V1CampaignFlightDatesSet } from '../models/V1CampaignFlightDatesSet';
import { V1CampaignJobIdSet } from '../models/V1CampaignJobIdSet';
import { V1CampaignNameSet } from '../models/V1CampaignNameSet';
import { V1CampaignOrderLine } from '../models/V1CampaignOrderLine';
import { V1CampaignPoIdSet } from '../models/V1CampaignPoIdSet';
import { V1CampaignPoliticalIndependentExpenditureFormPathSet } from '../models/V1CampaignPoliticalIndependentExpenditureFormPathSet';
import { V1CampaignPoliticalIndependentExpenditureStateSet } from '../models/V1CampaignPoliticalIndependentExpenditureStateSet';
import { V1CampaignPoliticalTransparencySet } from '../models/V1CampaignPoliticalTransparencySet';
import { V1CampaignRefIDSet } from '../models/V1CampaignRefIDSet';
import { V1CampaignSearch } from '../models/V1CampaignSearch';
import { V1CampaignUnarchived } from '../models/V1CampaignUnarchived';
import { V1CancelAudienceGenerationRequest } from '../models/V1CancelAudienceGenerationRequest';
import { V1ClientRoles } from '../models/V1ClientRoles';
import { V1CloneAudienceRequest } from '../models/V1CloneAudienceRequest';
import { V1CombinationRule } from '../models/V1CombinationRule';
import { V1CommissionType } from '../models/V1CommissionType';
import { V1ComponentResult } from '../models/V1ComponentResult';
import { V1ComponentResults } from '../models/V1ComponentResults';
import { V1CostRange } from '../models/V1CostRange';
import { V1CpmPlus } from '../models/V1CpmPlus';
import { V1CreateEmailMappingRequest } from '../models/V1CreateEmailMappingRequest';
import { V1CreateReportResponse } from '../models/V1CreateReportResponse';
import { V1CreateRouteRequest } from '../models/V1CreateRouteRequest';
import { V1CreativeAdded } from '../models/V1CreativeAdded';
import { V1CreativeFile } from '../models/V1CreativeFile';
import { V1CreativeFileMetadata } from '../models/V1CreativeFileMetadata';
import { V1CreativeRemoved } from '../models/V1CreativeRemoved';
import { V1CreativeSearch } from '../models/V1CreativeSearch';
import { V1CredentialRepresentation } from '../models/V1CredentialRepresentation';
import { V1CreditCard } from '../models/V1CreditCard';
import { V1CronResponse } from '../models/V1CronResponse';
import { V1CsvExportConfig } from '../models/V1CsvExportConfig';
import { V1DataProduct } from '../models/V1DataProduct';
import { V1DataSource } from '../models/V1DataSource';
import { V1DataSourcesHighestUpcharge } from '../models/V1DataSourcesHighestUpcharge';
import { V1DayOfWeek } from '../models/V1DayOfWeek';
import { V1DeployMetadata } from '../models/V1DeployMetadata';
import { V1DestinationAllocation } from '../models/V1DestinationAllocation';
import { V1DetachExcludedAddressesRequest } from '../models/V1DetachExcludedAddressesRequest';
import { V1DeviceMainDetails } from '../models/V1DeviceMainDetails';
import { V1DeviceResultIDs } from '../models/V1DeviceResultIDs';
import { V1DeviceResults } from '../models/V1DeviceResults';
import { V1DeviceStatsResponse } from '../models/V1DeviceStatsResponse';
import { V1DeviceSubDetails } from '../models/V1DeviceSubDetails';
import { V1Distribution } from '../models/V1Distribution';
import { V1DownloadAudienceFileResponse } from '../models/V1DownloadAudienceFileResponse';
import { V1DownloadBundleResponse } from '../models/V1DownloadBundleResponse';
import { V1DownloadCreativeFileResponse } from '../models/V1DownloadCreativeFileResponse';
import { V1DownloadExclusionAddressesResponse } from '../models/V1DownloadExclusionAddressesResponse';
import { V1DownloadJobFileResponse } from '../models/V1DownloadJobFileResponse';
import { V1DownloadTOSAgreementResponse } from '../models/V1DownloadTOSAgreementResponse';
import { V1EmailDestinations } from '../models/V1EmailDestinations';
import { V1EmailMapping } from '../models/V1EmailMapping';
import { V1EmailTemplateConfig } from '../models/V1EmailTemplateConfig';
import { V1Entry } from '../models/V1Entry';
import { V1Excludes } from '../models/V1Excludes';
import { V1ExclusionAddresses } from '../models/V1ExclusionAddresses';
import { V1ExclusionAddressesAttached } from '../models/V1ExclusionAddressesAttached';
import { V1ExclusionAddressesDetached } from '../models/V1ExclusionAddressesDetached';
import { V1ExclusionAddressesFileMetaData } from '../models/V1ExclusionAddressesFileMetaData';
import { V1ExportConfig } from '../models/V1ExportConfig';
import { V1ExportDataResponse } from '../models/V1ExportDataResponse';
import { V1ExportType } from '../models/V1ExportType';
import { V1FTP } from '../models/V1FTP';
import { V1FileFilters } from '../models/V1FileFilters';
import { V1FileSubType } from '../models/V1FileSubType';
import { V1FrequencyConfig } from '../models/V1FrequencyConfig';
import { V1GetNewMoverMatchCountResponse } from '../models/V1GetNewMoverMatchCountResponse';
import { V1GetNotificationsResponse } from '../models/V1GetNotificationsResponse';
import { V1GetTemplateResponse } from '../models/V1GetTemplateResponse';
import { V1GetUserIPResponse } from '../models/V1GetUserIPResponse';
import { V1GlobalSearchResponse } from '../models/V1GlobalSearchResponse';
import { V1HighestCPMAudience } from '../models/V1HighestCPMAudience';
import { V1Includes } from '../models/V1Includes';
import { V1IntervalUnit } from '../models/V1IntervalUnit';
import { V1JWT } from '../models/V1JWT';
import { V1Job } from '../models/V1Job';
import { V1JobFileType } from '../models/V1JobFileType';
import { V1JobSearch } from '../models/V1JobSearch';
import { V1JobSubType } from '../models/V1JobSubType';
import { V1JobTemplate } from '../models/V1JobTemplate';
import { V1JobType } from '../models/V1JobType';
import { V1ListAccountingJobsResponse } from '../models/V1ListAccountingJobsResponse';
import { V1ListAssetsResponse } from '../models/V1ListAssetsResponse';
import { V1ListAudienceFoldersResponse } from '../models/V1ListAudienceFoldersResponse';
import { V1ListAudiencesResponse } from '../models/V1ListAudiencesResponse';
import { V1ListCampaignEventsResponse } from '../models/V1ListCampaignEventsResponse';
import { V1ListCommissionGroupsResponse } from '../models/V1ListCommissionGroupsResponse';
import { V1ListCreativeFoldersResponse } from '../models/V1ListCreativeFoldersResponse';
import { V1ListCreditCardsResponse } from '../models/V1ListCreditCardsResponse';
import { V1ListEmailMappingsResponse } from '../models/V1ListEmailMappingsResponse';
import { V1ListExclusionAddressesResponse } from '../models/V1ListExclusionAddressesResponse';
import { V1ListOfString } from '../models/V1ListOfString';
import { V1ListOrderLineEventsResponse } from '../models/V1ListOrderLineEventsResponse';
import { V1ListOrderLineJobsResponse } from '../models/V1ListOrderLineJobsResponse';
import { V1ListOrderLinesResponse } from '../models/V1ListOrderLinesResponse';
import { V1ListOrgSubscriptionsResponse } from '../models/V1ListOrgSubscriptionsResponse';
import { V1ListOrgUsersResponse } from '../models/V1ListOrgUsersResponse';
import { V1ListOrgsResponse } from '../models/V1ListOrgsResponse';
import { V1ListPixelsResponse } from '../models/V1ListPixelsResponse';
import { V1ListPublisherSubscriptionsResponse } from '../models/V1ListPublisherSubscriptionsResponse';
import { V1ListPublishersResponse } from '../models/V1ListPublishersResponse';
import { V1ListReportRunsResponse } from '../models/V1ListReportRunsResponse';
import { V1ListReportsResponse } from '../models/V1ListReportsResponse';
import { V1ListRoutesResponse } from '../models/V1ListRoutesResponse';
import { V1ListRulesResponse } from '../models/V1ListRulesResponse';
import { V1ListSchedulesResponse } from '../models/V1ListSchedulesResponse';
import { V1ListStatsResponse } from '../models/V1ListStatsResponse';
import { V1ListSubscriptionsResponse } from '../models/V1ListSubscriptionsResponse';
import { V1ListTOSAgreementsResponse } from '../models/V1ListTOSAgreementsResponse';
import { V1ListTotalStatsResponse } from '../models/V1ListTotalStatsResponse';
import { V1MainDetails } from '../models/V1MainDetails';
import { V1MatchMode } from '../models/V1MatchMode';
import { V1MatchScope } from '../models/V1MatchScope';
import { V1Medium } from '../models/V1Medium';
import { V1Message } from '../models/V1Message';
import { V1MessageType } from '../models/V1MessageType';
import { V1Metrics } from '../models/V1Metrics';
import { V1MetricsGranularity } from '../models/V1MetricsGranularity';
import { V1MonthlyFrequencyConfig } from '../models/V1MonthlyFrequencyConfig';
import { V1MoverMatchCount } from '../models/V1MoverMatchCount';
import { V1Notification } from '../models/V1Notification';
import { V1OAuthTokenRequest } from '../models/V1OAuthTokenRequest';
import { V1OrderLineAdTypeSet } from '../models/V1OrderLineAdTypeSet';
import { V1OrderLineApproved } from '../models/V1OrderLineApproved';
import { V1OrderLineArchived } from '../models/V1OrderLineArchived';
import { V1OrderLineAuditConditionsSet } from '../models/V1OrderLineAuditConditionsSet';
import { V1OrderLineCPMOverrideRemoved } from '../models/V1OrderLineCPMOverrideRemoved';
import { V1OrderLineCPMOverriden } from '../models/V1OrderLineCPMOverriden';
import { V1OrderLineCPMSet } from '../models/V1OrderLineCPMSet';
import { V1OrderLineCampaign } from '../models/V1OrderLineCampaign';
import { V1OrderLineClickThroughURLSet } from '../models/V1OrderLineClickThroughURLSet';
import { V1OrderLineCloneRequestFailed } from '../models/V1OrderLineCloneRequestFailed';
import { V1OrderLineCloneRequestSucceeded } from '../models/V1OrderLineCloneRequestSucceeded';
import { V1OrderLineCloned } from '../models/V1OrderLineCloned';
import { V1OrderLineCompleted } from '../models/V1OrderLineCompleted';
import { V1OrderLineCostSet } from '../models/V1OrderLineCostSet';
import { V1OrderLineCreated } from '../models/V1OrderLineCreated';
import { V1OrderLineDeleted } from '../models/V1OrderLineDeleted';
import { V1OrderLineDeployed } from '../models/V1OrderLineDeployed';
import { V1OrderLineDeployedToDestinationRTB } from '../models/V1OrderLineDeployedToDestinationRTB';
import { V1OrderLineDeployedToDestinationStackAdapt } from '../models/V1OrderLineDeployedToDestinationStackAdapt';
import { V1OrderLineDeployedToDestinationXandrCurate } from '../models/V1OrderLineDeployedToDestinationXandrCurate';
import { V1OrderLineDeployedToDestinationXandrInvest } from '../models/V1OrderLineDeployedToDestinationXandrInvest';
import { V1OrderLineDeployedWithConfig } from '../models/V1OrderLineDeployedWithConfig';
import { V1OrderLineDeploymentCancelled } from '../models/V1OrderLineDeploymentCancelled';
import { V1OrderLineDeploymentCancelling } from '../models/V1OrderLineDeploymentCancelling';
import { V1OrderLineDeploymentDestinationSet } from '../models/V1OrderLineDeploymentDestinationSet';
import { V1OrderLineDestinationRTBCreated } from '../models/V1OrderLineDestinationRTBCreated';
import { V1OrderLineDestinationRTBSet } from '../models/V1OrderLineDestinationRTBSet';
import { V1OrderLineDestinationStackAdaptCreated } from '../models/V1OrderLineDestinationStackAdaptCreated';
import { V1OrderLineDestinationStackAdaptSet } from '../models/V1OrderLineDestinationStackAdaptSet';
import { V1OrderLineDestinationXandrCurateCreated } from '../models/V1OrderLineDestinationXandrCurateCreated';
import { V1OrderLineDestinationXandrCurateSet } from '../models/V1OrderLineDestinationXandrCurateSet';
import { V1OrderLineDestinationXandrInvestCreated } from '../models/V1OrderLineDestinationXandrInvestCreated';
import { V1OrderLineDestinationXandrInvestSet } from '../models/V1OrderLineDestinationXandrInvestSet';
import { V1OrderLineDistributionSet } from '../models/V1OrderLineDistributionSet';
import { V1OrderLineEndTimeSet } from '../models/V1OrderLineEndTimeSet';
import { V1OrderLineErroredDeployingToDestinationRTB } from '../models/V1OrderLineErroredDeployingToDestinationRTB';
import { V1OrderLineErroredDeployingToDestinationStackAdapt } from '../models/V1OrderLineErroredDeployingToDestinationStackAdapt';
import { V1OrderLineErroredDeployingToDestinationXandrCurate } from '../models/V1OrderLineErroredDeployingToDestinationXandrCurate';
import { V1OrderLineErroredDeployingToDestinationXandrInvest } from '../models/V1OrderLineErroredDeployingToDestinationXandrInvest';
import { V1OrderLineEvent } from '../models/V1OrderLineEvent';
import { V1OrderLineFreeImpressionsSet } from '../models/V1OrderLineFreeImpressionsSet';
import { V1OrderLineImpressionsPerDaySet } from '../models/V1OrderLineImpressionsPerDaySet';
import { V1OrderLineImpressionsSet } from '../models/V1OrderLineImpressionsSet';
import { V1OrderLineJob } from '../models/V1OrderLineJob';
import { V1OrderLineJobIdSet } from '../models/V1OrderLineJobIdSet';
import { V1OrderLineLocked } from '../models/V1OrderLineLocked';
import { V1OrderLineMigrated } from '../models/V1OrderLineMigrated';
import { V1OrderLineMinimumImpressionsSet } from '../models/V1OrderLineMinimumImpressionsSet';
import { V1OrderLineNameSet } from '../models/V1OrderLineNameSet';
import { V1OrderLineNoteAppended } from '../models/V1OrderLineNoteAppended';
import { V1OrderLineNoteDeactivated } from '../models/V1OrderLineNoteDeactivated';
import { V1OrderLineNoteUpdated } from '../models/V1OrderLineNoteUpdated';
import { V1OrderLinePaidSet } from '../models/V1OrderLinePaidSet';
import { V1OrderLinePaused } from '../models/V1OrderLinePaused';
import { V1OrderLinePlayed } from '../models/V1OrderLinePlayed';
import { V1OrderLinePoIdSet } from '../models/V1OrderLinePoIdSet';
import { V1OrderLinePoliticalFieldsSet } from '../models/V1OrderLinePoliticalFieldsSet';
import { V1OrderLinePrepaySet } from '../models/V1OrderLinePrepaySet';
import { V1OrderLineRedeployVerificationFailed } from '../models/V1OrderLineRedeployVerificationFailed';
import { V1OrderLineRefIdSet } from '../models/V1OrderLineRefIdSet';
import { V1OrderLineRejected } from '../models/V1OrderLineRejected';
import { V1OrderLineReviewStarted } from '../models/V1OrderLineReviewStarted';
import { V1OrderLineSearch } from '../models/V1OrderLineSearch';
import { V1OrderLineSegmentConfigSet } from '../models/V1OrderLineSegmentConfigSet';
import { V1OrderLineStartTimeSet } from '../models/V1OrderLineStartTimeSet';
import { V1OrderLineStateSetToActive } from '../models/V1OrderLineStateSetToActive';
import { V1OrderLineStateSetToPaused } from '../models/V1OrderLineStateSetToPaused';
import { V1OrderLineStatus } from '../models/V1OrderLineStatus';
import { V1OrderLineStatusSetToDeploying } from '../models/V1OrderLineStatusSetToDeploying';
import { V1OrderLineStatusSetToDraft } from '../models/V1OrderLineStatusSetToDraft';
import { V1OrderLineStatusSetToPrevious } from '../models/V1OrderLineStatusSetToPrevious';
import { V1OrderLineStepFunctionSet } from '../models/V1OrderLineStepFunctionSet';
import { V1OrderLineTemplateTypeSet } from '../models/V1OrderLineTemplateTypeSet';
import { V1OrderLineUnarchived } from '../models/V1OrderLineUnarchived';
import { V1OrderLineUnlocked } from '../models/V1OrderLineUnlocked';
import { V1OrderLineViantAdelphicConfigurationSet } from '../models/V1OrderLineViantAdelphicConfigurationSet';
import { V1OrderLineViantAdelphicIDsSet } from '../models/V1OrderLineViantAdelphicIDsSet';
import { V1OrderLineViantAdelphicIDsSetCreativeID } from '../models/V1OrderLineViantAdelphicIDsSetCreativeID';
import { V1OrgData } from '../models/V1OrgData';
import { V1OrgLogo } from '../models/V1OrgLogo';
import { V1PayOrderLinesRequest } from '../models/V1PayOrderLinesRequest';
import { V1PdfExportConfig } from '../models/V1PdfExportConfig';
import { V1Pixel } from '../models/V1Pixel';
import { V1PixelCreated } from '../models/V1PixelCreated';
import { V1PixelNote } from '../models/V1PixelNote';
import { V1PixelUpdated } from '../models/V1PixelUpdated';
import { V1PoliticalFields } from '../models/V1PoliticalFields';
import { V1PoliticalTransparency } from '../models/V1PoliticalTransparency';
import { V1ProductType } from '../models/V1ProductType';
import { V1Publisher } from '../models/V1Publisher';
import { V1PublisherSubscription } from '../models/V1PublisherSubscription';
import { V1QueueDetails } from '../models/V1QueueDetails';
import { V1QueueHealth } from '../models/V1QueueHealth';
import { V1RebuildGlobalSearchRequest } from '../models/V1RebuildGlobalSearchRequest';
import { V1RebuildGlobalSearchResourceType } from '../models/V1RebuildGlobalSearchResourceType';
import { V1Report } from '../models/V1Report';
import { V1ReportGranularity } from '../models/V1ReportGranularity';
import { V1ReportRun } from '../models/V1ReportRun';
import { V1ReportRunStatus } from '../models/V1ReportRunStatus';
import { V1ReportType } from '../models/V1ReportType';
import { V1RequestOrgNameChangeRequest } from '../models/V1RequestOrgNameChangeRequest';
import { V1RequestSupportRequest } from '../models/V1RequestSupportRequest';
import { V1Result } from '../models/V1Result';
import { V1ResultIDs } from '../models/V1ResultIDs';
import { V1ResultMetrics } from '../models/V1ResultMetrics';
import { V1Results } from '../models/V1Results';
import { V1ReviewRequested } from '../models/V1ReviewRequested';
import { V1Route } from '../models/V1Route';
import { V1RouteJobReport } from '../models/V1RouteJobReport';
import { V1Rule } from '../models/V1Rule';
import { V1RuleSet } from '../models/V1RuleSet';
import { V1RunCommissionsRequest } from '../models/V1RunCommissionsRequest';
import { V1RunCommissionsResponse } from '../models/V1RunCommissionsResponse';
import { V1RunInvoicingRequest } from '../models/V1RunInvoicingRequest';
import { V1RunInvoicingResponse } from '../models/V1RunInvoicingResponse';
import { V1Schedule } from '../models/V1Schedule';
import { V1ScheduleFrequency } from '../models/V1ScheduleFrequency';
import { V1ScheduleStatus } from '../models/V1ScheduleStatus';
import { V1SendMessageRequest } from '../models/V1SendMessageRequest';
import { V1SetCampaignPoliticalFormRequest } from '../models/V1SetCampaignPoliticalFormRequest';
import { V1SlackTemplateConfig } from '../models/V1SlackTemplateConfig';
import { V1State } from '../models/V1State';
import { V1Stats } from '../models/V1Stats';
import { V1StatsResponse } from '../models/V1StatsResponse';
import { V1StringList } from '../models/V1StringList';
import { V1SubDetails } from '../models/V1SubDetails';
import { V1Subscription } from '../models/V1Subscription';
import { V1SubscriptionCreated } from '../models/V1SubscriptionCreated';
import { V1SubscriptionNote } from '../models/V1SubscriptionNote';
import { V1SubscriptionUpdated } from '../models/V1SubscriptionUpdated';
import { V1TOSAgreement } from '../models/V1TOSAgreement';
import { V1TargetJobSearch } from '../models/V1TargetJobSearch';
import { V1TargetSearch } from '../models/V1TargetSearch';
import { V1TemplateConfigType } from '../models/V1TemplateConfigType';
import { V1TemplateReport } from '../models/V1TemplateReport';
import { V1TemplateType } from '../models/V1TemplateType';
import { V1TemplateVariableValue } from '../models/V1TemplateVariableValue';
import { V1TimeframePreset } from '../models/V1TimeframePreset';
import { V1TriggerRouteResponse } from '../models/V1TriggerRouteResponse';
import { V1UnarchiveCreativeRequest } from '../models/V1UnarchiveCreativeRequest';
import { V1UnarchiveOrderLineRequest } from '../models/V1UnarchiveOrderLineRequest';
import { V1Upcharge } from '../models/V1Upcharge';
import { V1UpdateOrderLineRequest } from '../models/V1UpdateOrderLineRequest';
import { V1UpdateOrgRequest } from '../models/V1UpdateOrgRequest';
import { V1UploadAssetMetadata } from '../models/V1UploadAssetMetadata';
import { V1UploadAssetRequest } from '../models/V1UploadAssetRequest';
import { V1UploadCreativeFileRequest } from '../models/V1UploadCreativeFileRequest';
import { V1UploadExclusionAddressesRequest } from '../models/V1UploadExclusionAddressesRequest';
import { V1UploadOrderLineJobRequest } from '../models/V1UploadOrderLineJobRequest';
import { V1UploadOrgLogoMetadata } from '../models/V1UploadOrgLogoMetadata';
import { V1UploadTOSAgreementRequest } from '../models/V1UploadTOSAgreementRequest';
import { V1WebToHomeEvent } from '../models/V1WebToHomeEvent';
import { V1WebToHomeNoteType } from '../models/V1WebToHomeNoteType';
import { V1WeeklyFrequencyConfig } from '../models/V1WeeklyFrequencyConfig';
import { V2ArchiveTargetRequest } from '../models/V2ArchiveTargetRequest';
import { V2CreateJsonTargetRequest } from '../models/V2CreateJsonTargetRequest';
import { V2DownloadTargetFileResponse } from '../models/V2DownloadTargetFileResponse';
import { V2ListTargetFoldersResponse } from '../models/V2ListTargetFoldersResponse';
import { V2ListTargetsResponse } from '../models/V2ListTargetsResponse';
import { V2ReplaceFileMetaData } from '../models/V2ReplaceFileMetaData';
import { V2ReplaceTargetFileRequest } from '../models/V2ReplaceTargetFileRequest';
import { V2Target } from '../models/V2Target';
import { V2TargetJob } from '../models/V2TargetJob';
import { V2TargetStatus } from '../models/V2TargetStatus';
import { V2UnarchiveTargetRequest } from '../models/V2UnarchiveTargetRequest';
import { V2UploadTargetFileRequest } from '../models/V2UploadTargetFileRequest';
import { V3Advertiser } from '../models/V3Advertiser';
import { V3AuctionEvent } from '../models/V3AuctionEvent';
import { V3AugmentedLineItem } from '../models/V3AugmentedLineItem';
import { V3BrowserTarget } from '../models/V3BrowserTarget';
import { V3BudgetInterval } from '../models/V3BudgetInterval';
import { V3BudgetSchedulingSettings } from '../models/V3BudgetSchedulingSettings';
import { V3BuyerSeat } from '../models/V3BuyerSeat';
import { V3CampaignCreative } from '../models/V3CampaignCreative';
import { V3CampaignDeviceCaps } from '../models/V3CampaignDeviceCaps';
import { V3Condition } from '../models/V3Condition';
import { V3ConsoleCampaign } from '../models/V3ConsoleCampaign';
import { V3ContextualTargeting } from '../models/V3ContextualTargeting';
import { V3CountryTarget } from '../models/V3CountryTarget';
import { V3CreativeType } from '../models/V3CreativeType';
import { V3CurateCampaign } from '../models/V3CurateCampaign';
import { V3CustomDateRange } from '../models/V3CustomDateRange';
import { V3DaypartTarget } from '../models/V3DaypartTarget';
import { V3Deal } from '../models/V3Deal';
import { V3DealConfig } from '../models/V3DealConfig';
import { V3DealList } from '../models/V3DealList';
import { V3DealType } from '../models/V3DealType';
import { V3DeploySegmentsToCurateRequest } from '../models/V3DeploySegmentsToCurateRequest';
import { V3DeploymentDestinationConfigurations } from '../models/V3DeploymentDestinationConfigurations';
import { V3DirectMailCampaign } from '../models/V3DirectMailCampaign';
import { V3DirectMailConfiguration } from '../models/V3DirectMailConfiguration';
import { V3DomainListTarget } from '../models/V3DomainListTarget';
import { V3EngagementRateTarget } from '../models/V3EngagementRateTarget';
import { V3GenericDeployRequest } from '../models/V3GenericDeployRequest';
import { V3GovernmentLevel } from '../models/V3GovernmentLevel';
import { V3InventoryAttributeTarget } from '../models/V3InventoryAttributeTarget';
import { V3InventoryListTarget } from '../models/V3InventoryListTarget';
import { V3InvestCampaign } from '../models/V3InvestCampaign';
import { V3Language } from '../models/V3Language';
import { V3LanguageTarget } from '../models/V3LanguageTarget';
import { V3LegacyCampaign } from '../models/V3LegacyCampaign';
import { V3LineItem } from '../models/V3LineItem';
import { V3LineItemDeal } from '../models/V3LineItemDeal';
import { V3LineItemPixel } from '../models/V3LineItemPixel';
import { V3ListAdvertisersResponse } from '../models/V3ListAdvertisersResponse';
import { V3ListDeploymentsResponse } from '../models/V3ListDeploymentsResponse';
import { V3ListSegmentsResponse } from '../models/V3ListSegmentsResponse';
import { V3ListXandrDealListsResponse } from '../models/V3ListXandrDealListsResponse';
import { V3ListXandrDealsResponse } from '../models/V3ListXandrDealsResponse';
import { V3ListXandrLanguagesResponse } from '../models/V3ListXandrLanguagesResponse';
import { V3ListXandrRegionsResponse } from '../models/V3ListXandrRegionsResponse';
import { V3MemberDataSharing } from '../models/V3MemberDataSharing';
import { V3MemberDataSharingSegment } from '../models/V3MemberDataSharingSegment';
import { V3NonSeamlessInsertionOrder } from '../models/V3NonSeamlessInsertionOrder';
import { V3PacingStrategies } from '../models/V3PacingStrategies';
import { V3PoliticalContent } from '../models/V3PoliticalContent';
import { V3Position } from '../models/V3Position';
import { V3PositionTargets } from '../models/V3PositionTargets';
import { V3Profile } from '../models/V3Profile';
import { V3QueueRequest } from '../models/V3QueueRequest';
import { V3RTBCampaign } from '../models/V3RTBCampaign';
import { V3RTBConfiguration } from '../models/V3RTBConfiguration';
import { V3RTBCreativeMap } from '../models/V3RTBCreativeMap';
import { V3RTBCreativeMapping } from '../models/V3RTBCreativeMapping';
import { V3RTBOrderLine } from '../models/V3RTBOrderLine';
import { V3RTBOrderLineUpdateStatus } from '../models/V3RTBOrderLineUpdateStatus';
import { V3Region } from '../models/V3Region';
import { V3RegionTarget } from '../models/V3RegionTarget';
import { V3RegistrationForm } from '../models/V3RegistrationForm';
import { V3ResolveSegmentorIncidentResponse } from '../models/V3ResolveSegmentorIncidentResponse';
import { V3SGSegment } from '../models/V3SGSegment';
import { V3SeamlessInsertionOrder } from '../models/V3SeamlessInsertionOrder';
import { V3Segment } from '../models/V3Segment';
import { V3SegmentConfig } from '../models/V3SegmentConfig';
import { V3SegmentGroupTarget } from '../models/V3SegmentGroupTarget';
import { V3SegmentType } from '../models/V3SegmentType';
import { V3SegmentorDeploymentResults } from '../models/V3SegmentorDeploymentResults';
import { V3Split } from '../models/V3Split';
import { V3StackAdaptAd } from '../models/V3StackAdaptAd';
import { V3StackAdaptAudience } from '../models/V3StackAdaptAudience';
import { V3StackAdaptBidFactor } from '../models/V3StackAdaptBidFactor';
import { V3StackAdaptCampaign } from '../models/V3StackAdaptCampaign';
import { V3StackAdaptCampaignConfig } from '../models/V3StackAdaptCampaignConfig';
import { V3StackAdaptCampaignFlight } from '../models/V3StackAdaptCampaignFlight';
import { V3StackAdaptCampaignGoal } from '../models/V3StackAdaptCampaignGoal';
import { V3StackAdaptCampaignGroupConfig } from '../models/V3StackAdaptCampaignGroupConfig';
import { V3StackAdaptCampaignUpdateStatus } from '../models/V3StackAdaptCampaignUpdateStatus';
import { V3StackAdaptConfiguration } from '../models/V3StackAdaptConfiguration';
import { V3StackAdaptCreative } from '../models/V3StackAdaptCreative';
import { V3StackAdaptCreativeAdMapping } from '../models/V3StackAdaptCreativeAdMapping';
import { V3StackAdaptCreativeAdMappingStatus } from '../models/V3StackAdaptCreativeAdMappingStatus';
import { V3StackAdaptCreativeMap } from '../models/V3StackAdaptCreativeMap';
import { V3StackAdaptCreativeMapping } from '../models/V3StackAdaptCreativeMapping';
import { V3StackAdaptCreativeTactic } from '../models/V3StackAdaptCreativeTactic';
import { V3StackAdaptCreativeTag } from '../models/V3StackAdaptCreativeTag';
import { V3StackAdaptDayOption } from '../models/V3StackAdaptDayOption';
import { V3StackAdaptDayOptions } from '../models/V3StackAdaptDayOptions';
import { V3StackAdaptDayParting } from '../models/V3StackAdaptDayParting';
import { V3StackAdaptDeviceTypeRule } from '../models/V3StackAdaptDeviceTypeRule';
import { V3StackAdaptFlight } from '../models/V3StackAdaptFlight';
import { V3StackAdaptGeoTargeting } from '../models/V3StackAdaptGeoTargeting';
import { V3StackAdaptGlobalZipTargeting } from '../models/V3StackAdaptGlobalZipTargeting';
import { V3StackAdaptGoal } from '../models/V3StackAdaptGoal';
import { V3StackAdaptHourlyParting } from '../models/V3StackAdaptHourlyParting';
import { V3StackAdaptInventoryConfig } from '../models/V3StackAdaptInventoryConfig';
import { V3StackAdaptLibraryAd } from '../models/V3StackAdaptLibraryAd';
import { V3StackAdaptSegmentMap } from '../models/V3StackAdaptSegmentMap';
import { V3StackAdaptSegmentMapping } from '../models/V3StackAdaptSegmentMapping';
import { V3StackAdaptTacticAd } from '../models/V3StackAdaptTacticAd';
import { V3StackAdaptTacticCustomSegmentRule } from '../models/V3StackAdaptTacticCustomSegmentRule';
import { V3StackAdaptTacticDateRule } from '../models/V3StackAdaptTacticDateRule';
import { V3StackAdaptTacticDayTimeRule } from '../models/V3StackAdaptTacticDayTimeRule';
import { V3StackAdaptTacticLanguageRule } from '../models/V3StackAdaptTacticLanguageRule';
import { V3StackAdaptTacticWeekDayRule } from '../models/V3StackAdaptTacticWeekDayRule';
import { V3StackAdaptTimeSlot } from '../models/V3StackAdaptTimeSlot';
import { V3StackAdaptUserMetadata } from '../models/V3StackAdaptUserMetadata';
import { V3StackAdaptVastMedia } from '../models/V3StackAdaptVastMedia';
import { V3StackAdaptVastMediaData } from '../models/V3StackAdaptVastMediaData';
import { V3StackAdaptVastTracker } from '../models/V3StackAdaptVastTracker';
import { V3StackAdaptWeekdayParting } from '../models/V3StackAdaptWeekdayParting';
import { V3StartSegmentorIncidentRequest } from '../models/V3StartSegmentorIncidentRequest';
import { V3StartSegmentorIncidentResponse } from '../models/V3StartSegmentorIncidentResponse';
import { V3SupplyStrategies } from '../models/V3SupplyStrategies';
import { V3UserInfo } from '../models/V3UserInfo';
import { V3Valuation } from '../models/V3Valuation';
import { V3Values } from '../models/V3Values';
import { V3ViantAdelphicConfiguration } from '../models/V3ViantAdelphicConfiguration';
import { V3ViantCreativeConfig } from '../models/V3ViantCreativeConfig';
import { V3ViantSegmentConfig } from '../models/V3ViantSegmentConfig';
import { V3XandrConsoleConfiguration } from '../models/V3XandrConsoleConfiguration';
import { V3XandrCurateConfiguration } from '../models/V3XandrCurateConfiguration';
import { V3XandrInvestConfiguration } from '../models/V3XandrInvestConfiguration';

/* tslint:disable:no-unused-variable */
let primitives = [
                    "string",
                    "boolean",
                    "double",
                    "integer",
                    "long",
                    "float",
                    "number",
                    "any"
                 ];

const supportedMediaTypes: { [mediaType: string]: number } = {
  "application/json": Infinity,
  "application/octet-stream": 0,
  "application/x-www-form-urlencoded": 0
}


let enumsMap: Set<string> = new Set<string>([
    "Apqsv1HealthCondition",
    "Billingservicev1HealthCondition",
    "Billingservicev1InvoiceStatus",
    "Billingservicev2InvoiceStatus",
    "Campaignservicev1AdType",
    "Campaignservicev1HealthCondition",
    "Campaignservicev1JobStatus",
    "Campaignservicev1NoteType",
    "Campaignservicev1Status",
    "Creativeservicev1AdType",
    "Creativeservicev1AuditStatus",
    "Creativeservicev1DeploymentType",
    "Creativeservicev1Destination",
    "Creativeservicev1FileType",
    "Creativeservicev1HealthCondition",
    "Creativeservicev1Status",
    "Creativeservicev1Type",
    "Deployservicev3AuditStatus",
    "Deployservicev3DeploymentType",
    "Deployservicev3Destination",
    "Deployservicev3HealthCondition",
    "Deployservicev3Status",
    "Hagridv1HealthCondition",
    "Notificationservicev1HealthCondition",
    "Notificationservicev1Type",
    "Orgmanagerv1HealthCondition",
    "Orgmanagerv1NoteType",
    "Orgmanagerv1Status",
    "ProtobufNullValue",
    "Targetjobservicev1HealthCondition",
    "Targetjobservicev1JobStatus",
    "Targetjobservicev1NoteType",
    "Targetorchestratorv2FileType",
    "Targetorchestratorv2HealthCondition",
    "V1AccountingJobKind",
    "V1AssetType",
    "V1AudienceFileType",
    "V1AudienceStatus",
    "V1AudienceSubType",
    "V1AudienceType",
    "V1AutomationType",
    "V1BrandingMode",
    "V1CombinationRule",
    "V1CommissionType",
    "V1DataProduct",
    "V1DataSource",
    "V1DayOfWeek",
    "V1ExportType",
    "V1FileSubType",
    "V1IntervalUnit",
    "V1JobFileType",
    "V1JobSubType",
    "V1JobTemplate",
    "V1JobType",
    "V1MatchMode",
    "V1MatchScope",
    "V1Medium",
    "V1MessageType",
    "V1MetricsGranularity",
    "V1OrderLineStatus",
    "V1ProductType",
    "V1RebuildGlobalSearchResourceType",
    "V1ReportGranularity",
    "V1ReportRunStatus",
    "V1ReportType",
    "V1ScheduleFrequency",
    "V1ScheduleStatus",
    "V1State",
    "V1TemplateConfigType",
    "V1TemplateType",
    "V1TimeframePreset",
    "V1WebToHomeNoteType",
    "V2TargetStatus",
    "V3CreativeType",
    "V3GovernmentLevel",
    "V3RTBOrderLineUpdateStatus",
    "V3SegmentType",
    "V3StackAdaptCampaignUpdateStatus",
    "V3StackAdaptCreativeAdMappingStatus",
]);

let typeMap: {[index: string]: any} = {
    "AddAudienceRequest": AddAudienceRequest,
    "AddCreativeRequest": AddCreativeRequest,
    "AdvertisingPlatformServiceAddAccountRepRequest": AdvertisingPlatformServiceAddAccountRepRequest,
    "AdvertisingPlatformServiceAddCommissionGroupRequest": AdvertisingPlatformServiceAddCommissionGroupRequest,
    "AdvertisingPlatformServiceAddSalesRepRequest": AdvertisingPlatformServiceAddSalesRepRequest,
    "AdvertisingPlatformServiceAddUserRequest": AdvertisingPlatformServiceAddUserRequest,
    "AdvertisingPlatformServiceAppendOrderLineNoteRequest": AdvertisingPlatformServiceAppendOrderLineNoteRequest,
    "AdvertisingPlatformServiceBatchAddAudiencesRequest": AdvertisingPlatformServiceBatchAddAudiencesRequest,
    "AdvertisingPlatformServiceBatchAddCreativesRequest": AdvertisingPlatformServiceBatchAddCreativesRequest,
    "AdvertisingPlatformServiceBatchRemoveAudiencesRequest": AdvertisingPlatformServiceBatchRemoveAudiencesRequest,
    "AdvertisingPlatformServiceBatchRemoveCreativesRequest": AdvertisingPlatformServiceBatchRemoveCreativesRequest,
    "AdvertisingPlatformServiceCloneOrderLineRequest": AdvertisingPlatformServiceCloneOrderLineRequest,
    "AdvertisingPlatformServiceCreateOrgNoteRequest": AdvertisingPlatformServiceCreateOrgNoteRequest,
    "AdvertisingPlatformServiceDeactivateOrderLineNoteRequest": AdvertisingPlatformServiceDeactivateOrderLineNoteRequest,
    "AdvertisingPlatformServicePauseSchedulesRequest": AdvertisingPlatformServicePauseSchedulesRequest,
    "AdvertisingPlatformServicePlaySchedulesRequest": AdvertisingPlatformServicePlaySchedulesRequest,
    "AdvertisingPlatformServiceRemoveCommissionGroupRequest": AdvertisingPlatformServiceRemoveCommissionGroupRequest,
    "AdvertisingPlatformServiceRemoveUserRequest": AdvertisingPlatformServiceRemoveUserRequest,
    "AdvertisingPlatformServiceRetryReportRunRequest": AdvertisingPlatformServiceRetryReportRunRequest,
    "AdvertisingPlatformServiceRunOneSubscriptionRequest": AdvertisingPlatformServiceRunOneSubscriptionRequest,
    "AdvertisingPlatformServiceRunReportRequest": AdvertisingPlatformServiceRunReportRequest,
    "AdvertisingPlatformServiceTriggerRouteRequest": AdvertisingPlatformServiceTriggerRouteRequest,
    "AdvertisingPlatformServiceUpdateAssetRequest": AdvertisingPlatformServiceUpdateAssetRequest,
    "AdvertisingPlatformServiceUpdateEmailMappingRequest": AdvertisingPlatformServiceUpdateEmailMappingRequest,
    "AdvertisingPlatformServiceUpdateFTPRequest": AdvertisingPlatformServiceUpdateFTPRequest,
    "AdvertisingPlatformServiceUpdateOrderLineNoteRequest": AdvertisingPlatformServiceUpdateOrderLineNoteRequest,
    "AdvertisingPlatformServiceUpdatePixelRequest": AdvertisingPlatformServiceUpdatePixelRequest,
    "AdvertisingPlatformServiceUpdatePublisherRequest": AdvertisingPlatformServiceUpdatePublisherRequest,
    "AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest": AdvertisingPlatformServiceUpdatePublisherSubscriptionRequest,
    "AdvertisingPlatformServiceUpdateRouteRequest": AdvertisingPlatformServiceUpdateRouteRequest,
    "AdvertisingPlatformServiceUpdateRuleRequest": AdvertisingPlatformServiceUpdateRuleRequest,
    "AdvertisingPlatformServiceUpdateRuleSetRequest": AdvertisingPlatformServiceUpdateRuleSetRequest,
    "AdvertisingPlatformServiceUpdateSubscriptionRequest": AdvertisingPlatformServiceUpdateSubscriptionRequest,
    "ApproveOrderLineRequest": ApproveOrderLineRequest,
    "Apqsv1Checks": Apqsv1Checks,
    "Apqsv1Dependency": Apqsv1Dependency,
    "Apqsv1HealthCheck": Apqsv1HealthCheck,
    "Apqsv1Miscellanea": Apqsv1Miscellanea,
    "Apqsv1SystemStat": Apqsv1SystemStat,
    "Billingservicev1Checks": Billingservicev1Checks,
    "Billingservicev1CommissionGroup": Billingservicev1CommissionGroup,
    "Billingservicev1Dependency": Billingservicev1Dependency,
    "Billingservicev1HealthCheck": Billingservicev1HealthCheck,
    "Billingservicev1Invoice": Billingservicev1Invoice,
    "Billingservicev1ListInvoicesResponse": Billingservicev1ListInvoicesResponse,
    "Billingservicev1Miscellanea": Billingservicev1Miscellanea,
    "Billingservicev1Org": Billingservicev1Org,
    "Billingservicev1SystemStat": Billingservicev1SystemStat,
    "Billingservicev2Invoice": Billingservicev2Invoice,
    "Billingservicev2ListInvoicesResponse": Billingservicev2ListInvoicesResponse,
    "CPMContainsInformationRelatingToAClientCpmanization": CPMContainsInformationRelatingToAClientCpmanization,
    "Campaignservicev1Audience": Campaignservicev1Audience,
    "Campaignservicev1Campaign": Campaignservicev1Campaign,
    "Campaignservicev1Checks": Campaignservicev1Checks,
    "Campaignservicev1Creative": Campaignservicev1Creative,
    "Campaignservicev1Dependency": Campaignservicev1Dependency,
    "Campaignservicev1HealthCheck": Campaignservicev1HealthCheck,
    "Campaignservicev1ListCampaignsResponse": Campaignservicev1ListCampaignsResponse,
    "Campaignservicev1Miscellanea": Campaignservicev1Miscellanea,
    "Campaignservicev1Note": Campaignservicev1Note,
    "Campaignservicev1OrderLine": Campaignservicev1OrderLine,
    "Campaignservicev1SystemStat": Campaignservicev1SystemStat,
    "CancelOrderLineDeploymentRequest": CancelOrderLineDeploymentRequest,
    "Contact": Contact,
    "CreateCreditCardRequest": CreateCreditCardRequest,
    "CreateDeploymentRequest": CreateDeploymentRequest,
    "Creativeservicev1Audit": Creativeservicev1Audit,
    "Creativeservicev1AuditResult": Creativeservicev1AuditResult,
    "Creativeservicev1Checks": Creativeservicev1Checks,
    "Creativeservicev1Creative": Creativeservicev1Creative,
    "Creativeservicev1Dependency": Creativeservicev1Dependency,
    "Creativeservicev1FolderStats": Creativeservicev1FolderStats,
    "Creativeservicev1HealthCheck": Creativeservicev1HealthCheck,
    "Creativeservicev1ListCreativesResponse": Creativeservicev1ListCreativesResponse,
    "Creativeservicev1Miscellanea": Creativeservicev1Miscellanea,
    "Creativeservicev1NativeMetadata": Creativeservicev1NativeMetadata,
    "Creativeservicev1OrderLine": Creativeservicev1OrderLine,
    "Creativeservicev1SystemStat": Creativeservicev1SystemStat,
    "CreditCard": CreditCard,
    "CreditCard1": CreditCard1,
    "DeployMetadataDeployedCPM": DeployMetadataDeployedCPM,
    "DeployOrderLineRequest": DeployOrderLineRequest,
    "Deployservicev3Audit": Deployservicev3Audit,
    "Deployservicev3AuditResult": Deployservicev3AuditResult,
    "Deployservicev3Campaign": Deployservicev3Campaign,
    "Deployservicev3Checks": Deployservicev3Checks,
    "Deployservicev3Creative": Deployservicev3Creative,
    "Deployservicev3CreativeID": Deployservicev3CreativeID,
    "Deployservicev3Dependency": Deployservicev3Dependency,
    "Deployservicev3Deployment": Deployservicev3Deployment,
    "Deployservicev3HealthCheck": Deployservicev3HealthCheck,
    "Deployservicev3ListCampaignsResponse": Deployservicev3ListCampaignsResponse,
    "Deployservicev3ListCreativesResponse": Deployservicev3ListCreativesResponse,
    "Deployservicev3Miscellanea": Deployservicev3Miscellanea,
    "Deployservicev3NativeMetadata": Deployservicev3NativeMetadata,
    "Deployservicev3SystemStat": Deployservicev3SystemStat,
    "Deployservicev3Value": Deployservicev3Value,
    "DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries": DeviceStatsRequestWillHoldThePOSTRequestVarsForCustomizingDeviceStatisticsQueries,
    "ExistingUserWithNewFieldValues": ExistingUserWithNewFieldValues,
    "GetDefaultTemplateRequest": GetDefaultTemplateRequest,
    "GlobalSearchResponseCount": GlobalSearchResponseCount,
    "GoogleprotobufAny": GoogleprotobufAny,
    "GooglerpcStatus": GooglerpcStatus,
    "Hagridv1Checks": Hagridv1Checks,
    "Hagridv1Dependency": Hagridv1Dependency,
    "Hagridv1FileMetaData": Hagridv1FileMetaData,
    "Hagridv1HealthCheck": Hagridv1HealthCheck,
    "Hagridv1ListUsersResponse": Hagridv1ListUsersResponse,
    "Hagridv1Miscellanea": Hagridv1Miscellanea,
    "Hagridv1SystemStat": Hagridv1SystemStat,
    "Hagridv1User": Hagridv1User,
    "Job": Job,
    "LockOrderLineRequest": LockOrderLineRequest,
    "MoveOrgsRequest": MoveOrgsRequest,
    "Notification": Notification,
    "Notificationservicev1Checks": Notificationservicev1Checks,
    "Notificationservicev1Dependency": Notificationservicev1Dependency,
    "Notificationservicev1HealthCheck": Notificationservicev1HealthCheck,
    "Notificationservicev1Miscellanea": Notificationservicev1Miscellanea,
    "Notificationservicev1SystemStat": Notificationservicev1SystemStat,
    "OrderLineJobErrorDetail": OrderLineJobErrorDetail,
    "OrderLineViantAdelphicIDsSetAudienceID": OrderLineViantAdelphicIDsSetAudienceID,
    "Orgmanagerv1Checks": Orgmanagerv1Checks,
    "Orgmanagerv1CommissionGroup": Orgmanagerv1CommissionGroup,
    "Orgmanagerv1Contact": Orgmanagerv1Contact,
    "Orgmanagerv1Dependency": Orgmanagerv1Dependency,
    "Orgmanagerv1HealthCheck": Orgmanagerv1HealthCheck,
    "Orgmanagerv1Miscellanea": Orgmanagerv1Miscellanea,
    "Orgmanagerv1Note": Orgmanagerv1Note,
    "Orgmanagerv1Org": Orgmanagerv1Org,
    "Orgmanagerv1SystemStat": Orgmanagerv1SystemStat,
    "Orgmanagerv1Timeframe": Orgmanagerv1Timeframe,
    "Orgmanagerv1User": Orgmanagerv1User,
    "Orgmanagerv2ListUsersResponse": Orgmanagerv2ListUsersResponse,
    "Orgmanagerv2User": Orgmanagerv2User,
    "PauseOrderLineRequest": PauseOrderLineRequest,
    "PayInvoiceRequest": PayInvoiceRequest,
    "PaySetUpFeeRequest": PaySetUpFeeRequest,
    "PixelNote": PixelNote,
    "PlayOrderLineRequest": PlayOrderLineRequest,
    "PrepayRequest": PrepayRequest,
    "RejectOrderLineRequest": RejectOrderLineRequest,
    "RemoveAudienceRequest": RemoveAudienceRequest,
    "RemoveCreativeRequest": RemoveCreativeRequest,
    "RequestReviewRequest": RequestReviewRequest,
    "SetDistributionRequest": SetDistributionRequest,
    "StartReviewRequest": StartReviewRequest,
    "StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries": StatsRequestWillHoldThePOSTRequestVarsForCustomizingStatisticsQueries,
    "StreamResultOfV1DownloadAudienceFileResponse": StreamResultOfV1DownloadAudienceFileResponse,
    "StreamResultOfV1DownloadBundleResponse": StreamResultOfV1DownloadBundleResponse,
    "StreamResultOfV1DownloadCreativeFileResponse": StreamResultOfV1DownloadCreativeFileResponse,
    "StreamResultOfV1DownloadExclusionAddressesResponse": StreamResultOfV1DownloadExclusionAddressesResponse,
    "StreamResultOfV1DownloadJobFileResponse": StreamResultOfV1DownloadJobFileResponse,
    "StreamResultOfV1DownloadTOSAgreementResponse": StreamResultOfV1DownloadTOSAgreementResponse,
    "StreamResultOfV2DownloadTargetFileResponse": StreamResultOfV2DownloadTargetFileResponse,
    "SubscriptionNote": SubscriptionNote,
    "Targetjobservicev1Audience": Targetjobservicev1Audience,
    "Targetjobservicev1Checks": Targetjobservicev1Checks,
    "Targetjobservicev1Column": Targetjobservicev1Column,
    "Targetjobservicev1Dependency": Targetjobservicev1Dependency,
    "Targetjobservicev1Deployment": Targetjobservicev1Deployment,
    "Targetjobservicev1FolderStats": Targetjobservicev1FolderStats,
    "Targetjobservicev1HealthCheck": Targetjobservicev1HealthCheck,
    "Targetjobservicev1Miscellanea": Targetjobservicev1Miscellanea,
    "Targetjobservicev1Note": Targetjobservicev1Note,
    "Targetjobservicev1SystemStat": Targetjobservicev1SystemStat,
    "Targetjobservicev1Timeframe": Targetjobservicev1Timeframe,
    "Targetorchestratorv2Checks": Targetorchestratorv2Checks,
    "Targetorchestratorv2Column": Targetorchestratorv2Column,
    "Targetorchestratorv2Dependency": Targetorchestratorv2Dependency,
    "Targetorchestratorv2FileMetaData": Targetorchestratorv2FileMetaData,
    "Targetorchestratorv2FolderStats": Targetorchestratorv2FolderStats,
    "Targetorchestratorv2HealthCheck": Targetorchestratorv2HealthCheck,
    "Targetorchestratorv2Location": Targetorchestratorv2Location,
    "Targetorchestratorv2Miscellanea": Targetorchestratorv2Miscellanea,
    "Targetorchestratorv2SystemStat": Targetorchestratorv2SystemStat,
    "TheAdvertiserToCreate": TheAdvertiserToCreate,
    "TheAudienceToUpdate": TheAudienceToUpdate,
    "TheAutomationToUpdate": TheAutomationToUpdate,
    "TheCampaignToCreate": TheCampaignToCreate,
    "TheCampaignToUpdate": TheCampaignToUpdate,
    "TheCreativeToCreate": TheCreativeToCreate,
    "TheCreativeToUpdate": TheCreativeToUpdate,
    "TheDeploymentToCreate": TheDeploymentToCreate,
    "TheNoteToUpdate": TheNoteToUpdate,
    "TheOrderLineToUpdate": TheOrderLineToUpdate,
    "TheOrganizationToUpdate": TheOrganizationToUpdate,
    "TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask": TheReportToUpdateMustIncludeIdIdentifiesWhichReportAndTheNewValuesForEveryFieldListedInUpdateMask,
    "TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask": TheScheduleToUpdateMustIncludeIdIdentifiesWhichScheduleAndTheNewValuesForEveryFieldListedInUpdateMask,
    "TheSegmentToCreate": TheSegmentToCreate,
    "TheTargetToUpdate": TheTargetToUpdate,
    "TypeDate": TypeDate,
    "TypeMoney": TypeMoney,
    "UnlockOrderLineRequest": UnlockOrderLineRequest,
    "UpdateCPMsRequest": UpdateCPMsRequest,
    "UpdateDeploymentRequest": UpdateDeploymentRequest,
    "V1AccountingJob": V1AccountingJob,
    "V1AdditionalArguments": V1AdditionalArguments,
    "V1AdminInvoice": V1AdminInvoice,
    "V1AdminListNotificationsResponse": V1AdminListNotificationsResponse,
    "V1ArchiveCampaignRequest": V1ArchiveCampaignRequest,
    "V1ArchiveCreativeRequest": V1ArchiveCreativeRequest,
    "V1ArchiveOrderLineRequest": V1ArchiveOrderLineRequest,
    "V1Asset": V1Asset,
    "V1Assignment": V1Assignment,
    "V1AttachExcludedAddressesRequest": V1AttachExcludedAddressesRequest,
    "V1Attachment": V1Attachment,
    "V1AudienceAdded": V1AudienceAdded,
    "V1AudienceRemoved": V1AudienceRemoved,
    "V1AuditConditions": V1AuditConditions,
    "V1Authorization": V1Authorization,
    "V1Automation": V1Automation,
    "V1AuxiliaryFileFilter": V1AuxiliaryFileFilter,
    "V1Balance": V1Balance,
    "V1BatchAddAudiencesRequestAudience": V1BatchAddAudiencesRequestAudience,
    "V1BatchUpdateOrderLinesRequest": V1BatchUpdateOrderLinesRequest,
    "V1BatchUpdateOrderLinesResponse": V1BatchUpdateOrderLinesResponse,
    "V1BatchUpdateOrgsRequest": V1BatchUpdateOrgsRequest,
    "V1BatchUpdateOrgsResponse": V1BatchUpdateOrgsResponse,
    "V1BundleRequest": V1BundleRequest,
    "V1CPM": V1CPM,
    "V1CPMOverride": V1CPMOverride,
    "V1CampaignArchived": V1CampaignArchived,
    "V1CampaignCreated": V1CampaignCreated,
    "V1CampaignDeleted": V1CampaignDeleted,
    "V1CampaignEvent": V1CampaignEvent,
    "V1CampaignFlightDatesSet": V1CampaignFlightDatesSet,
    "V1CampaignJobIdSet": V1CampaignJobIdSet,
    "V1CampaignNameSet": V1CampaignNameSet,
    "V1CampaignOrderLine": V1CampaignOrderLine,
    "V1CampaignPoIdSet": V1CampaignPoIdSet,
    "V1CampaignPoliticalIndependentExpenditureFormPathSet": V1CampaignPoliticalIndependentExpenditureFormPathSet,
    "V1CampaignPoliticalIndependentExpenditureStateSet": V1CampaignPoliticalIndependentExpenditureStateSet,
    "V1CampaignPoliticalTransparencySet": V1CampaignPoliticalTransparencySet,
    "V1CampaignRefIDSet": V1CampaignRefIDSet,
    "V1CampaignSearch": V1CampaignSearch,
    "V1CampaignUnarchived": V1CampaignUnarchived,
    "V1CancelAudienceGenerationRequest": V1CancelAudienceGenerationRequest,
    "V1ClientRoles": V1ClientRoles,
    "V1CloneAudienceRequest": V1CloneAudienceRequest,
    "V1ComponentResult": V1ComponentResult,
    "V1ComponentResults": V1ComponentResults,
    "V1CostRange": V1CostRange,
    "V1CpmPlus": V1CpmPlus,
    "V1CreateEmailMappingRequest": V1CreateEmailMappingRequest,
    "V1CreateReportResponse": V1CreateReportResponse,
    "V1CreateRouteRequest": V1CreateRouteRequest,
    "V1CreativeAdded": V1CreativeAdded,
    "V1CreativeFile": V1CreativeFile,
    "V1CreativeFileMetadata": V1CreativeFileMetadata,
    "V1CreativeRemoved": V1CreativeRemoved,
    "V1CreativeSearch": V1CreativeSearch,
    "V1CredentialRepresentation": V1CredentialRepresentation,
    "V1CreditCard": V1CreditCard,
    "V1CronResponse": V1CronResponse,
    "V1CsvExportConfig": V1CsvExportConfig,
    "V1DataSourcesHighestUpcharge": V1DataSourcesHighestUpcharge,
    "V1DeployMetadata": V1DeployMetadata,
    "V1DestinationAllocation": V1DestinationAllocation,
    "V1DetachExcludedAddressesRequest": V1DetachExcludedAddressesRequest,
    "V1DeviceMainDetails": V1DeviceMainDetails,
    "V1DeviceResultIDs": V1DeviceResultIDs,
    "V1DeviceResults": V1DeviceResults,
    "V1DeviceStatsResponse": V1DeviceStatsResponse,
    "V1DeviceSubDetails": V1DeviceSubDetails,
    "V1Distribution": V1Distribution,
    "V1DownloadAudienceFileResponse": V1DownloadAudienceFileResponse,
    "V1DownloadBundleResponse": V1DownloadBundleResponse,
    "V1DownloadCreativeFileResponse": V1DownloadCreativeFileResponse,
    "V1DownloadExclusionAddressesResponse": V1DownloadExclusionAddressesResponse,
    "V1DownloadJobFileResponse": V1DownloadJobFileResponse,
    "V1DownloadTOSAgreementResponse": V1DownloadTOSAgreementResponse,
    "V1EmailDestinations": V1EmailDestinations,
    "V1EmailMapping": V1EmailMapping,
    "V1EmailTemplateConfig": V1EmailTemplateConfig,
    "V1Entry": V1Entry,
    "V1Excludes": V1Excludes,
    "V1ExclusionAddresses": V1ExclusionAddresses,
    "V1ExclusionAddressesAttached": V1ExclusionAddressesAttached,
    "V1ExclusionAddressesDetached": V1ExclusionAddressesDetached,
    "V1ExclusionAddressesFileMetaData": V1ExclusionAddressesFileMetaData,
    "V1ExportConfig": V1ExportConfig,
    "V1ExportDataResponse": V1ExportDataResponse,
    "V1FTP": V1FTP,
    "V1FileFilters": V1FileFilters,
    "V1FrequencyConfig": V1FrequencyConfig,
    "V1GetNewMoverMatchCountResponse": V1GetNewMoverMatchCountResponse,
    "V1GetNotificationsResponse": V1GetNotificationsResponse,
    "V1GetTemplateResponse": V1GetTemplateResponse,
    "V1GetUserIPResponse": V1GetUserIPResponse,
    "V1GlobalSearchResponse": V1GlobalSearchResponse,
    "V1HighestCPMAudience": V1HighestCPMAudience,
    "V1Includes": V1Includes,
    "V1JWT": V1JWT,
    "V1Job": V1Job,
    "V1JobSearch": V1JobSearch,
    "V1ListAccountingJobsResponse": V1ListAccountingJobsResponse,
    "V1ListAssetsResponse": V1ListAssetsResponse,
    "V1ListAudienceFoldersResponse": V1ListAudienceFoldersResponse,
    "V1ListAudiencesResponse": V1ListAudiencesResponse,
    "V1ListCampaignEventsResponse": V1ListCampaignEventsResponse,
    "V1ListCommissionGroupsResponse": V1ListCommissionGroupsResponse,
    "V1ListCreativeFoldersResponse": V1ListCreativeFoldersResponse,
    "V1ListCreditCardsResponse": V1ListCreditCardsResponse,
    "V1ListEmailMappingsResponse": V1ListEmailMappingsResponse,
    "V1ListExclusionAddressesResponse": V1ListExclusionAddressesResponse,
    "V1ListOfString": V1ListOfString,
    "V1ListOrderLineEventsResponse": V1ListOrderLineEventsResponse,
    "V1ListOrderLineJobsResponse": V1ListOrderLineJobsResponse,
    "V1ListOrderLinesResponse": V1ListOrderLinesResponse,
    "V1ListOrgSubscriptionsResponse": V1ListOrgSubscriptionsResponse,
    "V1ListOrgUsersResponse": V1ListOrgUsersResponse,
    "V1ListOrgsResponse": V1ListOrgsResponse,
    "V1ListPixelsResponse": V1ListPixelsResponse,
    "V1ListPublisherSubscriptionsResponse": V1ListPublisherSubscriptionsResponse,
    "V1ListPublishersResponse": V1ListPublishersResponse,
    "V1ListReportRunsResponse": V1ListReportRunsResponse,
    "V1ListReportsResponse": V1ListReportsResponse,
    "V1ListRoutesResponse": V1ListRoutesResponse,
    "V1ListRulesResponse": V1ListRulesResponse,
    "V1ListSchedulesResponse": V1ListSchedulesResponse,
    "V1ListStatsResponse": V1ListStatsResponse,
    "V1ListSubscriptionsResponse": V1ListSubscriptionsResponse,
    "V1ListTOSAgreementsResponse": V1ListTOSAgreementsResponse,
    "V1ListTotalStatsResponse": V1ListTotalStatsResponse,
    "V1MainDetails": V1MainDetails,
    "V1Message": V1Message,
    "V1Metrics": V1Metrics,
    "V1MonthlyFrequencyConfig": V1MonthlyFrequencyConfig,
    "V1MoverMatchCount": V1MoverMatchCount,
    "V1Notification": V1Notification,
    "V1OAuthTokenRequest": V1OAuthTokenRequest,
    "V1OrderLineAdTypeSet": V1OrderLineAdTypeSet,
    "V1OrderLineApproved": V1OrderLineApproved,
    "V1OrderLineArchived": V1OrderLineArchived,
    "V1OrderLineAuditConditionsSet": V1OrderLineAuditConditionsSet,
    "V1OrderLineCPMOverrideRemoved": V1OrderLineCPMOverrideRemoved,
    "V1OrderLineCPMOverriden": V1OrderLineCPMOverriden,
    "V1OrderLineCPMSet": V1OrderLineCPMSet,
    "V1OrderLineCampaign": V1OrderLineCampaign,
    "V1OrderLineClickThroughURLSet": V1OrderLineClickThroughURLSet,
    "V1OrderLineCloneRequestFailed": V1OrderLineCloneRequestFailed,
    "V1OrderLineCloneRequestSucceeded": V1OrderLineCloneRequestSucceeded,
    "V1OrderLineCloned": V1OrderLineCloned,
    "V1OrderLineCompleted": V1OrderLineCompleted,
    "V1OrderLineCostSet": V1OrderLineCostSet,
    "V1OrderLineCreated": V1OrderLineCreated,
    "V1OrderLineDeleted": V1OrderLineDeleted,
    "V1OrderLineDeployed": V1OrderLineDeployed,
    "V1OrderLineDeployedToDestinationRTB": V1OrderLineDeployedToDestinationRTB,
    "V1OrderLineDeployedToDestinationStackAdapt": V1OrderLineDeployedToDestinationStackAdapt,
    "V1OrderLineDeployedToDestinationXandrCurate": V1OrderLineDeployedToDestinationXandrCurate,
    "V1OrderLineDeployedToDestinationXandrInvest": V1OrderLineDeployedToDestinationXandrInvest,
    "V1OrderLineDeployedWithConfig": V1OrderLineDeployedWithConfig,
    "V1OrderLineDeploymentCancelled": V1OrderLineDeploymentCancelled,
    "V1OrderLineDeploymentCancelling": V1OrderLineDeploymentCancelling,
    "V1OrderLineDeploymentDestinationSet": V1OrderLineDeploymentDestinationSet,
    "V1OrderLineDestinationRTBCreated": V1OrderLineDestinationRTBCreated,
    "V1OrderLineDestinationRTBSet": V1OrderLineDestinationRTBSet,
    "V1OrderLineDestinationStackAdaptCreated": V1OrderLineDestinationStackAdaptCreated,
    "V1OrderLineDestinationStackAdaptSet": V1OrderLineDestinationStackAdaptSet,
    "V1OrderLineDestinationXandrCurateCreated": V1OrderLineDestinationXandrCurateCreated,
    "V1OrderLineDestinationXandrCurateSet": V1OrderLineDestinationXandrCurateSet,
    "V1OrderLineDestinationXandrInvestCreated": V1OrderLineDestinationXandrInvestCreated,
    "V1OrderLineDestinationXandrInvestSet": V1OrderLineDestinationXandrInvestSet,
    "V1OrderLineDistributionSet": V1OrderLineDistributionSet,
    "V1OrderLineEndTimeSet": V1OrderLineEndTimeSet,
    "V1OrderLineErroredDeployingToDestinationRTB": V1OrderLineErroredDeployingToDestinationRTB,
    "V1OrderLineErroredDeployingToDestinationStackAdapt": V1OrderLineErroredDeployingToDestinationStackAdapt,
    "V1OrderLineErroredDeployingToDestinationXandrCurate": V1OrderLineErroredDeployingToDestinationXandrCurate,
    "V1OrderLineErroredDeployingToDestinationXandrInvest": V1OrderLineErroredDeployingToDestinationXandrInvest,
    "V1OrderLineEvent": V1OrderLineEvent,
    "V1OrderLineFreeImpressionsSet": V1OrderLineFreeImpressionsSet,
    "V1OrderLineImpressionsPerDaySet": V1OrderLineImpressionsPerDaySet,
    "V1OrderLineImpressionsSet": V1OrderLineImpressionsSet,
    "V1OrderLineJob": V1OrderLineJob,
    "V1OrderLineJobIdSet": V1OrderLineJobIdSet,
    "V1OrderLineLocked": V1OrderLineLocked,
    "V1OrderLineMigrated": V1OrderLineMigrated,
    "V1OrderLineMinimumImpressionsSet": V1OrderLineMinimumImpressionsSet,
    "V1OrderLineNameSet": V1OrderLineNameSet,
    "V1OrderLineNoteAppended": V1OrderLineNoteAppended,
    "V1OrderLineNoteDeactivated": V1OrderLineNoteDeactivated,
    "V1OrderLineNoteUpdated": V1OrderLineNoteUpdated,
    "V1OrderLinePaidSet": V1OrderLinePaidSet,
    "V1OrderLinePaused": V1OrderLinePaused,
    "V1OrderLinePlayed": V1OrderLinePlayed,
    "V1OrderLinePoIdSet": V1OrderLinePoIdSet,
    "V1OrderLinePoliticalFieldsSet": V1OrderLinePoliticalFieldsSet,
    "V1OrderLinePrepaySet": V1OrderLinePrepaySet,
    "V1OrderLineRedeployVerificationFailed": V1OrderLineRedeployVerificationFailed,
    "V1OrderLineRefIdSet": V1OrderLineRefIdSet,
    "V1OrderLineRejected": V1OrderLineRejected,
    "V1OrderLineReviewStarted": V1OrderLineReviewStarted,
    "V1OrderLineSearch": V1OrderLineSearch,
    "V1OrderLineSegmentConfigSet": V1OrderLineSegmentConfigSet,
    "V1OrderLineStartTimeSet": V1OrderLineStartTimeSet,
    "V1OrderLineStateSetToActive": V1OrderLineStateSetToActive,
    "V1OrderLineStateSetToPaused": V1OrderLineStateSetToPaused,
    "V1OrderLineStatusSetToDeploying": V1OrderLineStatusSetToDeploying,
    "V1OrderLineStatusSetToDraft": V1OrderLineStatusSetToDraft,
    "V1OrderLineStatusSetToPrevious": V1OrderLineStatusSetToPrevious,
    "V1OrderLineStepFunctionSet": V1OrderLineStepFunctionSet,
    "V1OrderLineTemplateTypeSet": V1OrderLineTemplateTypeSet,
    "V1OrderLineUnarchived": V1OrderLineUnarchived,
    "V1OrderLineUnlocked": V1OrderLineUnlocked,
    "V1OrderLineViantAdelphicConfigurationSet": V1OrderLineViantAdelphicConfigurationSet,
    "V1OrderLineViantAdelphicIDsSet": V1OrderLineViantAdelphicIDsSet,
    "V1OrderLineViantAdelphicIDsSetCreativeID": V1OrderLineViantAdelphicIDsSetCreativeID,
    "V1OrgData": V1OrgData,
    "V1OrgLogo": V1OrgLogo,
    "V1PayOrderLinesRequest": V1PayOrderLinesRequest,
    "V1PdfExportConfig": V1PdfExportConfig,
    "V1Pixel": V1Pixel,
    "V1PixelCreated": V1PixelCreated,
    "V1PixelNote": V1PixelNote,
    "V1PixelUpdated": V1PixelUpdated,
    "V1PoliticalFields": V1PoliticalFields,
    "V1PoliticalTransparency": V1PoliticalTransparency,
    "V1Publisher": V1Publisher,
    "V1PublisherSubscription": V1PublisherSubscription,
    "V1QueueDetails": V1QueueDetails,
    "V1QueueHealth": V1QueueHealth,
    "V1RebuildGlobalSearchRequest": V1RebuildGlobalSearchRequest,
    "V1Report": V1Report,
    "V1ReportRun": V1ReportRun,
    "V1RequestOrgNameChangeRequest": V1RequestOrgNameChangeRequest,
    "V1RequestSupportRequest": V1RequestSupportRequest,
    "V1Result": V1Result,
    "V1ResultIDs": V1ResultIDs,
    "V1ResultMetrics": V1ResultMetrics,
    "V1Results": V1Results,
    "V1ReviewRequested": V1ReviewRequested,
    "V1Route": V1Route,
    "V1RouteJobReport": V1RouteJobReport,
    "V1Rule": V1Rule,
    "V1RuleSet": V1RuleSet,
    "V1RunCommissionsRequest": V1RunCommissionsRequest,
    "V1RunCommissionsResponse": V1RunCommissionsResponse,
    "V1RunInvoicingRequest": V1RunInvoicingRequest,
    "V1RunInvoicingResponse": V1RunInvoicingResponse,
    "V1Schedule": V1Schedule,
    "V1SendMessageRequest": V1SendMessageRequest,
    "V1SetCampaignPoliticalFormRequest": V1SetCampaignPoliticalFormRequest,
    "V1SlackTemplateConfig": V1SlackTemplateConfig,
    "V1Stats": V1Stats,
    "V1StatsResponse": V1StatsResponse,
    "V1StringList": V1StringList,
    "V1SubDetails": V1SubDetails,
    "V1Subscription": V1Subscription,
    "V1SubscriptionCreated": V1SubscriptionCreated,
    "V1SubscriptionNote": V1SubscriptionNote,
    "V1SubscriptionUpdated": V1SubscriptionUpdated,
    "V1TOSAgreement": V1TOSAgreement,
    "V1TargetJobSearch": V1TargetJobSearch,
    "V1TargetSearch": V1TargetSearch,
    "V1TemplateReport": V1TemplateReport,
    "V1TemplateVariableValue": V1TemplateVariableValue,
    "V1TriggerRouteResponse": V1TriggerRouteResponse,
    "V1UnarchiveCreativeRequest": V1UnarchiveCreativeRequest,
    "V1UnarchiveOrderLineRequest": V1UnarchiveOrderLineRequest,
    "V1Upcharge": V1Upcharge,
    "V1UpdateOrderLineRequest": V1UpdateOrderLineRequest,
    "V1UpdateOrgRequest": V1UpdateOrgRequest,
    "V1UploadAssetMetadata": V1UploadAssetMetadata,
    "V1UploadAssetRequest": V1UploadAssetRequest,
    "V1UploadCreativeFileRequest": V1UploadCreativeFileRequest,
    "V1UploadExclusionAddressesRequest": V1UploadExclusionAddressesRequest,
    "V1UploadOrderLineJobRequest": V1UploadOrderLineJobRequest,
    "V1UploadOrgLogoMetadata": V1UploadOrgLogoMetadata,
    "V1UploadTOSAgreementRequest": V1UploadTOSAgreementRequest,
    "V1WebToHomeEvent": V1WebToHomeEvent,
    "V1WeeklyFrequencyConfig": V1WeeklyFrequencyConfig,
    "V2ArchiveTargetRequest": V2ArchiveTargetRequest,
    "V2CreateJsonTargetRequest": V2CreateJsonTargetRequest,
    "V2DownloadTargetFileResponse": V2DownloadTargetFileResponse,
    "V2ListTargetFoldersResponse": V2ListTargetFoldersResponse,
    "V2ListTargetsResponse": V2ListTargetsResponse,
    "V2ReplaceFileMetaData": V2ReplaceFileMetaData,
    "V2ReplaceTargetFileRequest": V2ReplaceTargetFileRequest,
    "V2Target": V2Target,
    "V2TargetJob": V2TargetJob,
    "V2UnarchiveTargetRequest": V2UnarchiveTargetRequest,
    "V2UploadTargetFileRequest": V2UploadTargetFileRequest,
    "V3Advertiser": V3Advertiser,
    "V3AuctionEvent": V3AuctionEvent,
    "V3AugmentedLineItem": V3AugmentedLineItem,
    "V3BrowserTarget": V3BrowserTarget,
    "V3BudgetInterval": V3BudgetInterval,
    "V3BudgetSchedulingSettings": V3BudgetSchedulingSettings,
    "V3BuyerSeat": V3BuyerSeat,
    "V3CampaignCreative": V3CampaignCreative,
    "V3CampaignDeviceCaps": V3CampaignDeviceCaps,
    "V3Condition": V3Condition,
    "V3ConsoleCampaign": V3ConsoleCampaign,
    "V3ContextualTargeting": V3ContextualTargeting,
    "V3CountryTarget": V3CountryTarget,
    "V3CurateCampaign": V3CurateCampaign,
    "V3CustomDateRange": V3CustomDateRange,
    "V3DaypartTarget": V3DaypartTarget,
    "V3Deal": V3Deal,
    "V3DealConfig": V3DealConfig,
    "V3DealList": V3DealList,
    "V3DealType": V3DealType,
    "V3DeploySegmentsToCurateRequest": V3DeploySegmentsToCurateRequest,
    "V3DeploymentDestinationConfigurations": V3DeploymentDestinationConfigurations,
    "V3DirectMailCampaign": V3DirectMailCampaign,
    "V3DirectMailConfiguration": V3DirectMailConfiguration,
    "V3DomainListTarget": V3DomainListTarget,
    "V3EngagementRateTarget": V3EngagementRateTarget,
    "V3GenericDeployRequest": V3GenericDeployRequest,
    "V3InventoryAttributeTarget": V3InventoryAttributeTarget,
    "V3InventoryListTarget": V3InventoryListTarget,
    "V3InvestCampaign": V3InvestCampaign,
    "V3Language": V3Language,
    "V3LanguageTarget": V3LanguageTarget,
    "V3LegacyCampaign": V3LegacyCampaign,
    "V3LineItem": V3LineItem,
    "V3LineItemDeal": V3LineItemDeal,
    "V3LineItemPixel": V3LineItemPixel,
    "V3ListAdvertisersResponse": V3ListAdvertisersResponse,
    "V3ListDeploymentsResponse": V3ListDeploymentsResponse,
    "V3ListSegmentsResponse": V3ListSegmentsResponse,
    "V3ListXandrDealListsResponse": V3ListXandrDealListsResponse,
    "V3ListXandrDealsResponse": V3ListXandrDealsResponse,
    "V3ListXandrLanguagesResponse": V3ListXandrLanguagesResponse,
    "V3ListXandrRegionsResponse": V3ListXandrRegionsResponse,
    "V3MemberDataSharing": V3MemberDataSharing,
    "V3MemberDataSharingSegment": V3MemberDataSharingSegment,
    "V3NonSeamlessInsertionOrder": V3NonSeamlessInsertionOrder,
    "V3PacingStrategies": V3PacingStrategies,
    "V3PoliticalContent": V3PoliticalContent,
    "V3Position": V3Position,
    "V3PositionTargets": V3PositionTargets,
    "V3Profile": V3Profile,
    "V3QueueRequest": V3QueueRequest,
    "V3RTBCampaign": V3RTBCampaign,
    "V3RTBConfiguration": V3RTBConfiguration,
    "V3RTBCreativeMap": V3RTBCreativeMap,
    "V3RTBCreativeMapping": V3RTBCreativeMapping,
    "V3RTBOrderLine": V3RTBOrderLine,
    "V3Region": V3Region,
    "V3RegionTarget": V3RegionTarget,
    "V3RegistrationForm": V3RegistrationForm,
    "V3ResolveSegmentorIncidentResponse": V3ResolveSegmentorIncidentResponse,
    "V3SGSegment": V3SGSegment,
    "V3SeamlessInsertionOrder": V3SeamlessInsertionOrder,
    "V3Segment": V3Segment,
    "V3SegmentConfig": V3SegmentConfig,
    "V3SegmentGroupTarget": V3SegmentGroupTarget,
    "V3SegmentorDeploymentResults": V3SegmentorDeploymentResults,
    "V3Split": V3Split,
    "V3StackAdaptAd": V3StackAdaptAd,
    "V3StackAdaptAudience": V3StackAdaptAudience,
    "V3StackAdaptBidFactor": V3StackAdaptBidFactor,
    "V3StackAdaptCampaign": V3StackAdaptCampaign,
    "V3StackAdaptCampaignConfig": V3StackAdaptCampaignConfig,
    "V3StackAdaptCampaignFlight": V3StackAdaptCampaignFlight,
    "V3StackAdaptCampaignGoal": V3StackAdaptCampaignGoal,
    "V3StackAdaptCampaignGroupConfig": V3StackAdaptCampaignGroupConfig,
    "V3StackAdaptConfiguration": V3StackAdaptConfiguration,
    "V3StackAdaptCreative": V3StackAdaptCreative,
    "V3StackAdaptCreativeAdMapping": V3StackAdaptCreativeAdMapping,
    "V3StackAdaptCreativeMap": V3StackAdaptCreativeMap,
    "V3StackAdaptCreativeMapping": V3StackAdaptCreativeMapping,
    "V3StackAdaptCreativeTactic": V3StackAdaptCreativeTactic,
    "V3StackAdaptCreativeTag": V3StackAdaptCreativeTag,
    "V3StackAdaptDayOption": V3StackAdaptDayOption,
    "V3StackAdaptDayOptions": V3StackAdaptDayOptions,
    "V3StackAdaptDayParting": V3StackAdaptDayParting,
    "V3StackAdaptDeviceTypeRule": V3StackAdaptDeviceTypeRule,
    "V3StackAdaptFlight": V3StackAdaptFlight,
    "V3StackAdaptGeoTargeting": V3StackAdaptGeoTargeting,
    "V3StackAdaptGlobalZipTargeting": V3StackAdaptGlobalZipTargeting,
    "V3StackAdaptGoal": V3StackAdaptGoal,
    "V3StackAdaptHourlyParting": V3StackAdaptHourlyParting,
    "V3StackAdaptInventoryConfig": V3StackAdaptInventoryConfig,
    "V3StackAdaptLibraryAd": V3StackAdaptLibraryAd,
    "V3StackAdaptSegmentMap": V3StackAdaptSegmentMap,
    "V3StackAdaptSegmentMapping": V3StackAdaptSegmentMapping,
    "V3StackAdaptTacticAd": V3StackAdaptTacticAd,
    "V3StackAdaptTacticCustomSegmentRule": V3StackAdaptTacticCustomSegmentRule,
    "V3StackAdaptTacticDateRule": V3StackAdaptTacticDateRule,
    "V3StackAdaptTacticDayTimeRule": V3StackAdaptTacticDayTimeRule,
    "V3StackAdaptTacticLanguageRule": V3StackAdaptTacticLanguageRule,
    "V3StackAdaptTacticWeekDayRule": V3StackAdaptTacticWeekDayRule,
    "V3StackAdaptTimeSlot": V3StackAdaptTimeSlot,
    "V3StackAdaptUserMetadata": V3StackAdaptUserMetadata,
    "V3StackAdaptVastMedia": V3StackAdaptVastMedia,
    "V3StackAdaptVastMediaData": V3StackAdaptVastMediaData,
    "V3StackAdaptVastTracker": V3StackAdaptVastTracker,
    "V3StackAdaptWeekdayParting": V3StackAdaptWeekdayParting,
    "V3StartSegmentorIncidentRequest": V3StartSegmentorIncidentRequest,
    "V3StartSegmentorIncidentResponse": V3StartSegmentorIncidentResponse,
    "V3SupplyStrategies": V3SupplyStrategies,
    "V3UserInfo": V3UserInfo,
    "V3Valuation": V3Valuation,
    "V3Values": V3Values,
    "V3ViantAdelphicConfiguration": V3ViantAdelphicConfiguration,
    "V3ViantCreativeConfig": V3ViantCreativeConfig,
    "V3ViantSegmentConfig": V3ViantSegmentConfig,
    "V3XandrConsoleConfiguration": V3XandrConsoleConfiguration,
    "V3XandrCurateConfiguration": V3XandrCurateConfiguration,
    "V3XandrInvestConfiguration": V3XandrInvestConfiguration,
}

export class ObjectSerializer {
    public static findCorrectType(data: any, expectedType: string) {
        if (data == undefined) {
            return expectedType;
        } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        } else if (expectedType === "Date") {
            return expectedType;
        } else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }

            if (!typeMap[expectedType]) {
                return expectedType; // w/e we don't know the type
            }

            // Check the discriminator
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType; // the type does not have a discriminator. use it.
            } else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if(typeMap[discriminatorType]){
                        return discriminatorType; // use the type given in the discriminator
                    } else {
                        return expectedType; // discriminator did not map to a type
                    }
                } else {
                    return expectedType; // discriminator was not present (or an empty string)
                }
            }
        }
    }

    public static serialize(data: any, type: string, format: string) {
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            let transformedData: any[] = [];
            for (let index in data) {
                let date = data[index];
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        } else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth()+1
                month = month < 10 ? "0" + month.toString() : month.toString()
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();

                return data.getFullYear() + "-" + month + "-" + day;
            } else {
                return data.toISOString();
            }
        } else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) { // in case we dont know the type
                return data;
            }

            // Get the actual type of this object
            type = this.findCorrectType(data, type);

            // get the map for the correct type.
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance: {[index: string]: any} = {};
            for (let index in attributeTypes) {
                let attributeType = attributeTypes[index];
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }

    public static deserialize(data: any, type: string, format: string) {
        // polymorphism may change the actual type.
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
            let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
            subType = subType.substring(0, subType.length - 1); // Type> => Type
            let transformedData: any[] = [];
            for (let index in data) {
                let date = data[index];
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        } else if (type === "Date") {
            return new Date(data);
        } else {
            if (enumsMap.has(type)) {// is Enum
                return data;
            }

            if (!typeMap[type]) { // dont know the type
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let index in attributeTypes) {
                let attributeType = attributeTypes[index];
                let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
                if (value !== undefined) {
                    instance[attributeType.name] = value;
                }
            }
            return instance;
        }
    }


    /**
     * Normalize media type
     *
     * We currently do not handle any media types attributes, i.e. anything
     * after a semicolon. All content is assumed to be UTF-8 compatible.
     */
    public static normalizeMediaType(mediaType: string | undefined): string | undefined {
        if (mediaType === undefined) {
            return undefined;
        }
        return mediaType.split(";")[0].trim().toLowerCase();
    }

    /**
     * From a list of possible media types, choose the one we can handle best.
     *
     * The order of the given media types does not have any impact on the choice
     * made.
     */
    public static getPreferredMediaType(mediaTypes: Array<string>): string {
        /** According to OAS 3 we should default to json */
        if (!mediaTypes) {
            return "application/json";
        }

        const normalMediaTypes = mediaTypes.map(this.normalizeMediaType);
        let selectedMediaType: string | undefined = undefined;
        let selectedRank: number = -Infinity;
        for (const mediaType of normalMediaTypes) {
            if (supportedMediaTypes[mediaType!] > selectedRank) {
                selectedMediaType = mediaType;
                selectedRank = supportedMediaTypes[mediaType!];
            }
        }

        if (selectedMediaType === undefined) {
            throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
        }

        return selectedMediaType!;
    }

    /**
     * Convert data to a string according the given media type
     */
    public static stringify(data: any, mediaType: string): string {
        if (mediaType === "text/plain") {
            return String(data);
        }

        if (mediaType === "application/json") {
            return JSON.stringify(data);
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }

    /**
     * Parse data from a string according to the given media type
     */
    public static parse(rawData: string, mediaType: string | undefined) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }

        if (mediaType === "text/plain") {
            return rawData;
        }

        if (mediaType === "application/json") {
            return JSON.parse(rawData);
        }

        if (mediaType === "text/html") {
            return rawData;
        }

        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}
